export default {
  domainDirectory: {
    title: "Domain Rasmi", subtitle: "Sahkan alamat rasmi di sini. Ketik untuk menyalin.", available: " boleh dicapai",
    loading: "Memuatkan domain…", loadFailed: "Domain gagal dimuatkan", retry: "Muat semula", empty: "Tiada domain aktif",
    tapToCopy: "Ketik untuk salin", checking: "Menyemak", checkingShort: "Menyemak", online: "Boleh dicapai", offline: "Sambungan tamat masa",
    waiting: "Menunggu semakan", timeout: "Tamat masa", testAll: "Uji semua domain sekarang", updatedEveryFifteenSeconds: "Sambungan diuji secara automatik setiap 15 saat",
    saveReminder: "Ambil tangkapan skrin halaman ini untuk menyimpan maklumat domain", copied: "Domain disalin",
    names: { primary: "Domain utama", chinaAccel: "Pecutan China", secondary: "Domain sekunder" },
  },
  nickname: {"edit": "Edit nama samaran", "hint": "2–20 huruf Cina/Inggeris, digit atau _", "saved": "Nama samaran disimpan", "taken": "Nama samaran ini sudah digunakan", "invalid": "Gunakan 2–20 huruf Cina/Inggeris, digit atau _. Nama terpelihara tidak dibenarkan.", "failed": "Tidak dapat disimpan. Sila cuba lagi."},
  common: {
    confirm: "Sahkan",
    cancel: "Batal",
    search: "Cari",
    language: "Bahasa",
    switched: "Ditukar",
    currentLanguage: "Bahasa Semasa",
    selectLanguage: "Pilih Bahasa",
    loading: "Memuatkan...",
    loadingMore: "Memuatkan lagi...",
    noMoreData: "Tiada lagi data",
    noData: "Tiada data",
    serverUnavailable: "Pelayan tidak tersedia buat sementara waktu",
    loadFailed: "Gagal memuatkan",
    requestFailed: "Permintaan gagal",
    projectName: "PANTA MARKET",
    duplicateSubmission: "Sila jangan hantar semula",
    fee: "Yuran",
    tip: "Notis",
    connecting: "Menyambung...",
    connectWalletFirst: "Sila sambungkan dompet anda dahulu",
    connect: "Sambung",
    insufficientBalance: "Baki tidak mencukupi",
    developing: "Ciri sedang dibangunkan",
    copyFailed: "Gagal menyalin",
    sessionAuthRelogin: "Log masuk semula",
    sessionAuthStay: "Kekal",
    pleaseRelogin: "Sesi tamat, sila log masuk semula",
    retry: "Ketik untuk cuba lagi",
    submit: "Hantar",
    pager: {
      prevPage: "Sebelum",
      nextPage: "Seterusnya",
      pageOf: "{page} / {totalPages}",
      jumpToPage: "Pergi ke",
      jumpConfirm: "Pergi",
    },
  },
  tabbar: {
    home: "Laman Utama",
    market: "Garis Masa",
    timeline: "Garis Masa",
    prediction: "Ramalan Kontrak Acara AI",
    createMarket: "Cipta Pasaran",
    planet: "Planet",
    trade: "Dagangan",
    finance: "Kewangan",
    fund: "Dana",
    assets: "Aset",
    planethistory: "Sejarah"
  },
  tradeMenu: {
    contract: "Kontrak Acara",
    insurance: "Insurans",
    spot: "Spot",
    flash: "Pertukaran Pantas"
  },
  home: {
    searchPlaceholder: "BTC",
    bannerTitle: "PANTA MARKET",
    bannerSubtitle: "Ramalan AI · Kontrak acara · Analisis pintar",
    predictionCategories: {
      hot: "Garis Masa",
      sports: "Sukan",
      world: "Dunia",
      politics: "Politik",
      economy: "Ekonomi"
    },
    predictionSubCategories: {
      crypto: "Spot",
      forex: "Forex",
      commodities: "Komoditi"
    },
    features: {
      recharge: "Isi Semula",
      rechargeDesc: "Deposit pantas",
      contract: "Kontrak Peristiwa",
      contractDesc: "Alat kewangan yang inovatif",
      predict: "Ramalan AI",
      fund: "PANTA MARKET Treasury",
      invite: "Jemput Rakan",
      global: "Nod Global"
    },
    insurance: {
      title: "Kumpulan Insurans Kontrak (TAKER)",
      aiPoolTitle: "Kolam Insurans AI",
      ordinaryPoolTitle: "Kolam Nilai Insurans Biasa",
      approxUsdt: "≈ {amount} U",
      approxPantaRef: "≈ {amount} PANTA (ruj.)",
      more: "Ketahui Lebih Lanjut",
      yesterday: "Ditambah Semalam",
      service: "Perkhidmatan Pintar"
    },
    market: {
      tabs: {
        main: "Utama",
        hot: "Popular",
        rise: "Kenaikan Tertinggi",
        price: "Harga"
      },
      headers: {
        pair: "Pasangan",
        latest: "Harga Terkini",
        change: "Perubahan 24j"
      },
      viewMore: "Lihat Lagi",
      collapse: "Tutup"
    },
    announcement: {
      title: "Pengumuman",
      heading: "Pengumuman",
      text: "Selamat datang ke PANTA MARKET. Di sini, anda akan mengalami sistem AI dan insurans ramalan unik yang dicipta oleh PANTA MARKET, membolehkan anda menyertai pasaran ramalan WEB3 dengan mudah dan memulakan perjalanan kekayaan anda.",
      time: "2025/11/19 10:00",
      gotIt: "Faham",
      viewDetail: "Lihat butiran",
      systemLabel: "Pengumuman sistem"
    },
    timePeriods: {
      "1min": "1 Minit",
      "30min": "30 Minit",
      "1hour": "1 Jam"
    },
    footer: {
      australia: "· Australia",
      uae: "· Emiriah Arab Bersatu",
      attention: "· PERHATIAN:",
      attentionText: "PANTA MARKET ialah syarikat pasaran ramalan WEB3 berasaskan AI yang diuruskan sendiri. Kami tidak membenarkan mana-mana pihak ketiga untuk mengutip bayaran dalam apa jua bentuk atau nama. Untuk pertanyaan, sila hubungi perkhidmatan pelanggan rasmi di: {email}"
    },
    timeframes: {
      "1s": "1 min",
      "1m": "1 min",
      "5m": "5 min",
      "15m": "15 min",
      "1h": "1 jam",
      "4h": "4 jam",
      "1d": "1 hari"
    },
    statusHotEn: "HOT",
    yes: "Ya",
    no: "Tidak",
    hotBannerTitle: "Kontrak acara",
    homeBanner: {
      s1t1: "Berkuasa AI",
      s1t2: "Ekologi teras AstralX",
      s1cta: "AstralX",
      s2t: "Dana Galaxy",
      s2s1: "Ketahui perlindungan modal",
      s2s2: "dan peraturan pembayaran",
      s2cta: "Langgan",
      s3s: "Ramalan harga",
      s3cta: "Ramal",
    },
    catCrypto: "Kripto",
    catMetal: "Logam",
    catSports: "Sukan",
    catPolitics: "Politik",
    catEntertainment: "Hiburan",
    statusHot: "Hangat",
    statusLocked: "Dikunci",
    statusLive: "Langsung",
    statusLockedWait: "Dikunci, menunggu penyelesaian",
    jouleUnit: "JOULE",
    nowLabel: "Sekarang",
    endAtFallback: "--",
    predictionLabel: "Prediction",
    rise: "Up",
    fall: "Down",
    viewMoreOptions: "Lihat {n} lagi pilihan",
    categoryAll: "Semua",
    categoryCrypto: "Kripto",
    categoryEquity: "Ekuiti",
    categoryCommodity: "Komoditi",
    categoryForex: "Foreks",
    categoryMetal: "Logam"
  },
  withdraw: {
    title: "Pengeluaran",
    headerTitle: "Pengeluaran",
    address: "Alamat Pengeluaran",
    addressLabel: "Alamat Pengeluaran",
    addressPlaceholder: "Masukkan atau tampal alamat",
    network: "Rangkaian",
    selectNetwork: "Pilih Rangkaian",
    networkHint: "Sila pastikan alamat pengeluaran sepadan dengan rangkaian yang dipilih",
    withdrawAmount: "Jumlah Pengeluaran",
    receiveAmount: "Jumlah Diterima",
    networkFee: "Yuran Rangkaian",
    submit: "Sahkan Pengeluaran",
    submitButton: "Keluarkan",
    balance: "Baki",
    all: "Semua",
    amountPlaceholder: "Sila masukkan",
    minimumWithdrawal: "Jumlah pengeluaran minimum: {amount} USDT",
    minimumWithdrawalTAKER: "Jumlah pengeluaran minimum: {amount}TAKER",
    fee: "Yuran",
    confirm: "Sahkan",
    confirmTitle: "Sahkan Tindakan",
    confirmContent: "Adakah anda pasti mahu meneruskan?",
    toasts: {
      fetchFailed: "Gagal mendapatkan aset",
      enterAddress: "Sila masukkan alamat pengeluaran",
      enterValidAmount: "Sila masukkan jumlah pengeluaran yang sah",
      insufficientBalance: "Baki tidak mencukupi",
      minimumAmount: "Jumlah pengeluaran minimum ialah {amount} USDT",
      processing: "Memproses...",
      success: "Pengeluaran berjaya!",
      requestSuccess: "Permintaan pengeluaran berjaya",
      requestFailed: "Pengeluaran gagal, sila cuba lagi",
      notConfigured: "Withdrawals are not available yet"
    },
    addressHint: "Withdrawal will be sent to your wallet address"
  },
  deposit: {
    headerTitle: "Deposit",
    connectPrompt: "Sila sambungkan dompet anda untuk membuat deposit",
    loading: "Memuatkan...",
    depositAddress: "Alamat Deposit",
    minimumDeposit: "*Deposit minimum 10.0000 USDT",
    depositAmount: "Jumlah Deposit",
    balance: "Baki",
    amaBalance: "Baki TAKER",
    amount: "Jumlah",
    amountPlaceholder: "Masukkan jumlah deposit",
    minimumNotice: "*Minimum {min} {token}",
    processing: "Memproses...",
    confirm: "Sahkan Deposit",
    confirmTitle: "Sahkan Tindakan",
    confirmContent: "Adakah anda pasti mahu meneruskan?",
    helpText: "Deposit akan memanggil kaedah recharge kontrak pintar, kelulusan token TAKER diperlukan",
    toasts: {
      copySuccess: "Berjaya disalin",
      dataLoadFailed: "Gagal memuatkan data",
      enterValidAmount: "Sila masukkan jumlah deposit yang sah",
      invalidAmount: "Jumlah deposit tidak boleh kurang daripada {min} TAKER",
      invalidAddress: "Alamat deposit tidak sah",
      checkingAllowance: "Menyemak had...",
      approving: "Meluluskan...",
      approveSuccess: "Kelulusan berjaya",
      depositing: "Membuat deposit...",
      depositSuccess: "Deposit berjaya",
      depositFailed: "Deposit gagal",
      balanceLoadFailed: "Tidak dapat membaca baki USDT ujian. Muat semula dan cuba lagi",
      contractError: "Panggilan kontrak gagal, sila semak baki",
      userCancelled: "Anda telah membatalkan operasi",
      insufficientFunds: "Baki tidak mencukupi",
      wrongNetwork: "Sila tukar ke rangkaian yang betul",
      requestingAuth: "Meminta kebenaran dompet...",
      waitingConfirmation: "Menunggu pengesahan transaksi...",
      transactionFailed: "Gagal memulakan transaksi",
      transactionCancelled: "Anda telah membatalkan transaksi",
      genericError: "Transaksi gagal",
      configNotReady: "Deposits are not available yet",
      invalidTxHash: "Please enter a valid transaction hash",
      claimPending: "Deposit submitted, credit pending",
      cannotGetBalance: "Cannot get balance, please refresh and try again"
    },
    depositNotice: "Please transfer to the following address, the system will process automatically after arrival",
    usdtBalance: "USDT Balance"
  },
  team: {
    headerTitle: "Pasukan Saya",
    contractEarnings: "Pendapatan Kontrak Saya",
    btcFund: "Hasil kewangan",
    stats: {
      teamSubscribed: "Stake pasukan",
      personalSubscribed: "Stake peribadi",
      totalTeam: "Volum pasukan",
      periodTeam: "Pendapatan pasukan",
      periodPersonal: "Volum peribadi",
      personalEarnings: "Pendapatan terkumpul peribadi",
      teamEarnings: "Pendapatan pasukan",
      personalVolume: "Volum peribadi",
      teamVolume: "Volum pasukan",
      personalPower: "Kuasa Peribadi",
      teamTotalPower: "Jumlah Kuasa Pasukan"
    },
    links: {
      invite: "Jemput Rakan",
      details: "Butiran Pasukan"
    },
    inviteBannerTitle: "Jemput rakan buka kunci komisen pasukan",
    inviteBannerSubtitle: "Buka kunci komisen pasukan anda",
    inviteBannerCta: "Sertai sekarang",
    unclassifiedHint: "Sumber bayaran lama perlu disemak: {amount} {asset}"
  },
  my: {
    headerTitle: "Saya",
    login: "Ketik untuk Log Masuk",
    inviteCode: "Kod Jemputan:",
    groups: {
      common: "Fungsi Biasa",
      trading: "Dagangan",
      finance: "Kewangan",
      help: "Bantuan"
    },
    features: {
      invite: "Jemput Rakan",
      team: "Pasukan Saya",
      insurance: "Insurans Kontrak Peristiwa",
      contract: "Kontrak Peristiwa",
      exchange: "Tukar",
      fund: "Dana Perbendaharaan AI",
      communitySquare: "Dataran Komuniti",
      createEvent: "Cipta Acara",
      community: "Komuniti Rasmi",
      terms: "Syarat Perkhidmatan",
      announcement: "Pengumuman",
      privacy: "Dasar Privasi",
      aboutUs: "Tentang Kami"
    }
  },
  finance: {
    title: "Halaman kewangan sedang dalam pembangunan..."
  },
  wealthAccess: {
    exchangeThresholdFailed: "Pertukaran gagal: syarat belum dipenuhi",
    internalPrice: "Harga dalaman",
    marketPrice: "Harga pasaran",
    coinBasis: "Berasaskan koin",
    legacyBasis: "Berasaskan koin",
    contractBasis: "Asas penyelesaian",
    unitPrice: "Harga unit belian",
    quotaUsed: "Belian dalaman sepanjang hayat",
    quotaRemaining: "Baki kuota harga dalaman",
    quotaHint: "Had sepanjang hayat {limit} PANTA merentas semua pelan. Penutupan harga dalaman, matang atau perubahan VIP tidak menetapkan semula jumlah.",
    principal: "Prinsipal",
    principalReturn: "Prinsipal dipulangkan semasa matang",
    dailyYield: "Hasil kasar harian",
    coinYieldHint: "Hasil kasar harian = prinsipal PANTA × kadar tahunan ÷ 360, dibundarkan ke bawah dalam unit atom. Harga tidak mengubah syiling kontrak. Agihan mengikut peraturan berkenaan.",
    legacyHint: "Kontrak berasaskan koin. Bayaran balik prinsipal PANTA ditukar pada harga matang kontrak.",
    quotaError: "Kuota harga dalaman dilebihi. Kurangkan kuantiti; pesanan tidak dipecah atau ditukar ke harga pasaran secara automatik.",
    permissionChanged: "Pelan ini tidak lagi tersedia untuk VIP anda. Senarai telah dikemas kini.",
    quoteChanged: "Harga atau kelayakan berubah. Semak sebut harga baharu dan sahkan semula.",
    quoteExpired: "Sebut harga tamat tempoh. Segar semula dan semak sebelum mengesahkan.",
    retryQuote: "Segar semula harga",
    stakeGateTitle: "Syarat staking untuk menjual PANTA",
    stakeGateBody: "VIP{vip}: staking aktif {staked} PANTA; perlu {required} PANTA; kurang {shortfall} PANTA. Hanya jualan disekat, belian tidak terjejas.",
    goStake: "Ke staking",
    refreshEligibility: "Segar semula kelayakan",
  },
  fundPage: {
    heroTitle: "Ganjaran PANTA diagihkan setiap hari",
    heroDesc: "Langgan dana Galaxy untuk dividen tahunan",
    learnMore: "Ketahui lebih lanjut",
    allProducts: "Semua produk",
    subscribe: "Langgan",
    stake: "Stake",
    stakePreview: "Pratonton stake",
    searchCoin: "Cari syiling",
    allPeriods: "Semua tempoh",
    colCoin: "Nama dana",
    colApy: "APY berasaskan token",
    colTerm: "Tempoh",
    fixedTerm: "Tetap",
    galaxyProduct: "Galaxy {n}",
    termLabel: "Tempoh",
    apyLabel: "APY",
    stakeCap: "Pegangan individu",
    stakeAmount: "Jumlah stake",
    estEarnings: "Anggaran hasil",
    stakeDisclaimer: "Hasil adalah ilustrasi, tidak dijamin. Kira-kira 70% ke baki tersedia dan 30% ke dana percubaan; dana percubaan dibuka selepas ~3× pusing ganti.",
    stakeSuccess: "Stake berjaya",
    annualized: "APY rujukan",
    perShareYield: "Hasil / 10k (WBS)",
    dayUnit: "h",
    empty: "Belum ada produk dana",
    loadFailed: "Gagal dimuatkan",
    rulesTitle: "Maklumat dana",
    gotIt: "Faham",
    pantaAvailable: "PANTA tersedia",
    activeFaceValue: "Unit aktif",
    totalReward: "Hasil terkumpul dana (PANTA)",
    fundYieldUnavailable: "--/Sila kemas kini perkhidmatan",
    effectiveVip: "Tahap berkesan",
    myHoldings: "Sejarah pembelian dana",
    faceValue: "Nilai",
    maturity: "Matang",
    stakeStart: "Masa stake",
    pantaPrice: "Harga PANTA",
    noMoreHoldings: "Tiada lagi pegangan",
    subscriptionStatus: {
      ACTIVE: "Aktif",
      SETTLED: "Selesai",
      CANCELLED: "Dibatalkan",
      MANUAL_REVIEW: "Semakan manual",
    },
    minPanta: "Min. PANTA",
    pantaAmount: "Kuantiti langganan (PANTA)",
    stepHint: "Ganda {step}, min {min}",
    getQuote: "Dapatkan sebut harga",
    confirmStake: "Sahkan stake",
    jouleDebit: "Debit JOULE",
    expectedPanta: "PANTA digadai",
    quoteExpires: "Sebut harga tamat",
    unavailable: "Belum tersedia",
    invalidAmount: "Masukkan kuantiti PANTA mengikut langkah yang sah",
    quoteFailed: "Sebut harga gagal",
    rewards: "Ganjaran dana",
    unlock: "Kumpulan pembekuan PANTA",
    unlockProgress: "Volum digunakan",
    pantaLedger: "Lejar PANTA"
  },
  finanfund: {
    title: "PANTA MARKET Treasury Fund",
    subtitle: "Mudah, Cekap, Pendapatan Mudah",
    productName: "PANTA MARKET Treasury Fund",
    minAmount: "Jumlah Minimum",
    incomeRatio: "Kadar Pulangan",
    lockPeriod: "Tempoh Kunci",
    dailyReturn: "Pulangan Harian",
    earning: "Diperolehi",
    redemptionRules: "Peraturan Penebusan",
    rules: {
      rule1: "Dana Perbendaharaan TAKER tidak boleh ditebus selepas penjagaan",
      rule2: "Pendapatan harian dikreditkan secara automatik",
      rule3: "Jumlah terkunci akan dikembalikan selepas tempoh kunci tamat"
    },
    subscription: "Langganan",
    amountPlaceholder: "Masukkan jumlah",
    balance: "Baki",
    availableFunds: "Dana Tersedia",
    all: "Semua",
    subscribeButton: "Langgan",
    toasts: {
      productIdNotExist: "ID produk tidak wujud",
      enterValidAmount: "Sila masukkan jumlah langganan yang sah",
      minAmountRequired: "Jumlah langganan tidak boleh kurang daripada {amount} USDT",
      subscribeSuccess: "Langganan berjaya",
      subscribeFailed: "Langganan gagal"
    }
  },
  community: {
    title: "Komuniti Rasmi",
    bannerTitle1: "Sertai Komuniti Kami",
    bannerTitle2: "Berhubung dengan Pengguna Global",
    linkCopied: "Pautan Disalin"
  },
  invite: {
    headerTitle: "Jemput Rakan",
    rulesEntry: "Peraturan Jemputan",
    subtitle: "Untung dari setiap dagangan pasukan",
    mainTitle: "Jemput & Untung",
    description: "Kongsi pautan — rakan berdagang, anda dapat ganjaran",
    yourCode: "Kod Jemputan",
    shareLink: "Pautan Kongsi",
    inviteButton: "Jemput Rakan",
    subTitle: "Dapatkan Komisen Tinggi",
    viewRules: "Lihat Peraturan",
    rulesLink: "Lihat Peraturan Rujukan >",
    rulesTitle: "Peraturan Rujukan",
    rules: {
      commissionTable: {
        title: "PANTA MARKET Trading Volume Commission Table",
        headers: {
          level: "Level",
          personalTurnover: "Personal Vol",
          teamTurnover: "Team Vol",
          commission: "Team Comm"
        }
      }
    },
    inviteBoxTitle: "Jemput Rakan",
    referralCode: "Kod Rujukan",
    inviteLink: "Pautan Jemputan",
    loading: "Memuatkan...",
    copyButton: "Salin Pautan Jemputan",
    toasts: {
      emptyContent: "Kandungan kosong",
      copySuccess: "Berjaya disalin",
      bindSuccess: "Pengikatan berjaya",
      bindFailed: "Pengikatan gagal",
      alreadyBound: "Atasan sudah diikat; tidak boleh ditukar",
      loginFirst: "Sila sambung dompet dahulu",
      invalidCode: "Sila masukkan kod jemputan atau alamat dompet yang sah",
      cannotBindSelf: "Tidak boleh mengikat diri sendiri",
    },
    boundLabel: "Atasan telah diikat",
    modalDesc: "Belum mengikat atasan. Masukkan kod jemputan atau alamat dompet untuk sertai ganjaran pasukan. Maklumat pautan diisi automatik; jika tiada, alamat atasan lalai dipraisi.",
    bindPlaceholder: "Masukkan kod jemputan atau alamat dompet",
    bindButton: "Ikat",
    binding: "Mengikat…",
    bindSuperior: "Ikat atasan",
  },
  assets: {
    insuranceFrozen: "Kuota Beku Insurans (JOULE)",
    available: "Tersedia",
    deposit: "Deposit",
    withdraw: "Pengeluaran",
    myAccountRecords: "Rekod Akaun Saya",
    nodeEquityHint: "Node equity valued in USDT, not a cash deposit",
    nodeEquityRate: "Applied rate: {rate}%",
    nodeEquitySources: {
      PERSONAL: "Personal insurance equity",
      TEAM: "Team insurance equity",
      ADMIN: "Platform Airdrop",
      AI_INSURANCE: "AI insurance node equity payout",
      BACKFILL: "AI insurance node equity backfill",
      OTHER: "Node equity credited",
    },
    recordTypes: {
      NODE_EQUITY_CREDIT: "Node equity credited",
      BET_STAKE: "Pembekuan pertaruhan",
      WIN_PAYOUT: "Keuntungan dagangan",
      LOSS_SETTLEMENT: "Kerugian dagangan",
      REFUND: "Bayaran balik",
      INSURANCE_PREMIUM: "Perbelanjaan premium",
      INSURANCE_PAYOUT: "Bayaran insurans",
      INSURANCE_TRANSFER_IN: "Pindahan masuk insurans",
      INSURANCE_TRANSFER_OUT: "Pindahan keluar insurans",
      NETWORK_DIFFERENTIAL: "Ganjaran pembezaan dagangan",
      NETWORK_PEER: "Ganjaran setara dagangan",
      NETWORK_UNLOCK: "Buka kunci pendapatan",
      EVENT_INSURANCE_PAYOUT: "Bayaran nod kuasa kira",
      EVENT_INSURANCE_PEER: "Ganjaran setara kuasa kira",
      TRANSFER_IN: "Pindahan masuk",
      TRANSFER_OUT: "Pindahan keluar",
      PREMIUM_LOCK: "Kunci premium",
      PREMIUM_SETTLE: "Perbelanjaan premium",
      PREMIUM_REFUND: "Bayaran balik premium",
      WEALTH_SUBSCRIPTION: "Langganan dana",
      SUBSCRIPTION_LOCK: "Kunci cagaran",
      WEALTH_DAILY_REWARD: "Faedah harian dana",
      WEALTH_TEAM_REWARD: "Ganjaran pasukan dana",
      MATURITY_RELEASE: "Pulangan modal matang",
      WEALTH_UNLOCK: "Buka kunci pendapatan",
      COPY_SHARE_HOLD: "Copy share held",
      COPY_SHARE_RELEASE: "Copy share unfrozen / refunded",
      COPY_SHARE_PAYOUT: "Copy share paid out",
      COPY_TRADE_TRANSFER_OUT: "Transfer to copy account",
      COPY_TRADE_TRANSFER_IN: "Transfer from copy account",
      COPY_WIN_PAYOUT: "Copy profit",
      COPY_LOSS_SETTLEMENT: "Copy loss",
      COPY_TRANSFER_IN: "Deposit to copy account",
      COPY_TRANSFER_OUT: "Withdraw from copy account",
      COPY_SHARE_PAYOUT_IN: "Copy share received",
      COPY_SHARE_POOL_IN: "Copy share pool in",
      COPY_SHARE_POOL_REFUND: "Copy share pool refund",
      COPY_SHARE_POOL_MIGRATION: "Copy share pool migration",
      COPY_FLOW: "Copy trade record"
    },
    recordCategories: {
      NODE_EQUITY: "Node equity",
      TRADE_PNL: "Untung/rugi dagangan",
      PREMIUM: "Premium",
      INSURANCE_PAYOUT: "Bayaran insurans",
      TEAM_REWARD: "Ganjaran pasukan",
      COPY: "Copy Details",
      COPY_TRADE_PNL: "Copy P&L",
      COPY_SHARE: "Copy share",
      COPY_TRANSFER: "Copy transfer",
      WEALTH_REWARD: "Faedah dana",
      UNLOCK: "Buka kunci",
      PRINCIPAL: "Langganan/pulangan",
      TRANSFER: "Pindahan dalaman"
    },
    amountPendingReview: "Jumlah menunggu semakan",
    creditedSplit: "Tersedia {available} · Beku {frozen}",
    creditedSplitPending: "Pecahan menunggu semakan",
    afterBalance: "Selepas: tersedia {available} · beku {frozen}",
    unlockHint: "Beku → tersedia; bukan pendapatan baharu",
    transferFromInsurance: "Akaun insurans",
    transferFromMain: "Akaun utama",
    all: "Semua",
    transfer: "Pemindahan",
    insuranceDeduction: "Potongan Insurans",
    insurancePayout: "Pembayaran Insurans",
    noRecords: "Tiada rekod",

    actions: {
      deposit: "Deposit",
      withdraw: "Pengeluaran",
      exchange: "Tukar",
      transfer: "Pemindahan"
    },
    loginPrompt: {
      text: "Sila sambungkan dompet anda dahulu",
      button: "Sambung"
    },
    toasts: {
      connectFailed: "Sambungan gagal, sila cuba lagi"
    },
    pantaUsdtRate: "1 PANTA = {price} USDT",
    buyNodeModal: {
      title: "Buy Trading Node",
      cancel: "Cancel Purchase",
      purchasing: "Purchasing...",
      confirm: "Confirm Purchase",
      availableBalance: "Available Balance",
      unavailable: "Not available yet",
      description: "Pay {amount}JOULE to get trading node access",
      insufficient: "Insufficient balance, please deposit first",
      success: "Purchase successful",
      failed: "Purchase failed, please retry"
    },
    transferToMain: "Transfer to Main System",
    mainSystemPanta: "Main System (PANTA)",
    jouleAvailable: "JOULE Available",
    detailTitle: "Asset Details",
    totalAssetsUsdt: "Estimated Total Value (USDT)",
    jouleConvert: "JOULE Converted (× rate)",
    usdtPart: "USDT Portion",
    totalSum: "Total",
    tradeFrozen: "Trade Frozen (JOULE)",
    financeReleaseFrozen: "Finance Release Frozen (JOULE)",
    insuranceAccountJoule: "Insurance (JOULE)",
    usdtAvailableLabel: "USDT Available",
    usdtFrozenLabel: "USDT Frozen",
    noHoldings: "No holdings yet",
    availableAssets: "Available Assets",
    tradeFrozenJoule: "Trade Frozen (JOULE)",
    payoutPower: "Compute Node Payout",
    payoutEquity: "AI Prediction Payout (JOULE)",
    mainAccount: "Dagangan",
    insuranceAccountShort: "Insurans",
    copyAccountShort: "Copy",
    tradingAccountHelpTitle: "Trading account balance",
    copyAvailableLabel: "Available",
    copyFrozenLabel: "Frozen",
    copyAccountJoule: "Akaun copy (JOULE)",
    copyTotalPnl: "PnL copy",
    transferSheet: {
      title: "Pemindahan",
      pairCopy: "Dagangan / Copy",
      pairInsurance: "Dagangan / Insurans",
      tradingAccount: "Akaun dagangan",
      copyAccount: "Akaun copy",
      insuranceAccount: "Akaun insurans",
      jouleHint: "Hanya pemindahan JOULE",
      submit: "Hantar",
      transferring: "Memindahkan...",
      success: "Pemindahan berjaya",
      failed: "Pemindahan gagal, cuba lagi",
    },
    computeNode: "Compute Nodes",
    stakedTotalPanta: "Fund Staked",
    stakedPlusRewardPanta: "Stake + Est. Earnings",
    stakedPlusRewardTipTitle: "Stake principal + estimated earnings",
    stakedPlusRewardTip:
      "Jumlah ini ialah prinsipal stake ditambah anggaran pendapatan.",
    stakedPrincipalLabel: "Prinsipal stake",
    stakedExpectedYieldLabel: "Anggaran hasil",
    annualEarningsPanta: "Fund Earnings",
    frozenTotalPanta: "Total Frozen",
    unlockedTotalPanta: "Total Unlocked",
    fundTeamPendingPanta: "Ganjaran Pasukan Dana Belum Dibayar (PANTA)",
    fundTeamPaidPanta: "Ganjaran Pasukan Dana Dibayar (PANTA)",
    pendingRewardPanta: "Pending Airdrop",
    paidRewardPanta: "Airdropped",
    expectedAirdropQuota: "Estimated Pending Airdrop",
    cumulativeAirdropValue: "Nilai airdrop terkumpul: {value} USDT",
    roundProgress: "Node Generation Progress",
    currentNodeCount: "Current Nodes",
    roundExpectedValue: "Est. this round: {value} USDT",
    historyTotalValue: "Historical total: {value} USDT",
    nextAirdropAt: "Next distribution: {time}",
    airdropEstimateUnavailable: "Unable to estimate",
    roundExpectedValueUnavailable: "Est. this round: unable to estimate",
    airdropEstimateHint: "Estimate only; actual settlement prevails",
    invalidNodeCount: "Invalid Nodes",
    deductedNodeCount: "Deducted Nodes",
    todayRelease: "Today Release",
    releaseFrozenPanta: "Release Frozen",
    unlockQuota: "Unlock Quota",
    unlockQuotaNote: "Today unlockable 0.0000",
    tradeNode: "Trade Node",
    tradeNodeDesc: "Upgrade to VIP3 and unlock trading benefits",
    tradeNodeHint: "Price: 2888 JOULE · Upgrade to VIP3",
    buyNode: "Buy Node",
    insuranceAccountRecordsShort: "Insurance"
  },
  wallet: {
    title: "Dompet Saya",
    address: "Alamat Dompet",
    addressCopied: "Alamat disalin",
    inviteCode: "Kod Jemputan",
    logout: "Log Keluar",
    login: "Log Masuk",
    toasts: {
      networkSwitchCancelled: "Penukaran rangkaian dibatalkan oleh pengguna",
      networkConfigNotFound: "Konfigurasi rangkaian tidak ditemui untuk {chainId}",
      signatureCancelled: "Tandatangan dibatalkan oleh pengguna",
      connectionFailed: "Gagal menyambung dompet",
      accountSwitched: "Akaun dompet ditukar, sila sambung semula",
      connectionTimedOut: "Sambungan tamat masa, sila cuba lagi",
      loginSuccess: "Log masuk berjaya",
      logoutSuccess: "Log keluar berjaya",
      switchNetwork: "Sila tukar ke {chainName} dalam dompet anda sebelum cuba untuk deposit",
      wrongChain: "Rangkaian tidak disokong, sila tukar ke {chainName}",
      switchingNetwork: "Menukar rangkaian...",
      switchNetworkFailed: "Penukaran rangkaian gagal, sila tukar secara manual ke {chainName} dalam dompet anda"
    }
  },
  market: {
    title: "Pasaran",
    banner: {
      title: "Kontrak Acara",
      desc: "Buka potensi pendapatan on-chain"
    },
    tabs: {
      main: "Syiling utama",
      rise: "Kenaikan tertinggi"
    },
    types: {
      crypto: "Mata Wang Kripto",
      stocks: "Saham AS",
      forex: "Forex",
      commodities: "Komoditi",
      favorites: "Kegemaran"
    },
    headers: {
      pair: "Pasangan dagangan",
      price: "Harga terkini",
      change: "Perubahan hari ini"
    },
    loading: "Memuatkan...",
    loadingMore: "Memuatkan lagi...",
    noMoreData: "Tiada lagi data"
  },
  notice: {
    loginRequired: "Sila log masuk untuk melihat pengumuman",
    empty: "Tiada pengumuman lagi",
    unpublished: "Dibatalkan",
    title: "Pengumuman",
    helpCenter: "Pusat Bantuan",
    noticeDetail: "Butiran Pengumuman",
    viewDetail: "Lihat butiran",
    pdfViewer: "Pemapar PDF",
    videoPlayer: "Pemain Video",
    imageViewer: "Pemapar Imej",
    documentViewer: "Pemapar Dokumen",
    clickToViewPdf: "Klik untuk melihat PDF",
    clickToViewDocument: "Klik untuk melihat dokumen",
    openInBrowser: "Buka dalam Pelayar",
    tryingViewer: "Mencuba kaedah {current}/{total}",
    pdfLoadFailed: "Pratonton PDF gagal dimuatkan, sila muat turun untuk melihat",
    downloadPdf: "Muat turun PDF",
    defaultCategory: "Notice"
  },
  trade: {
    title: "Kontrak Acara",
    nextRound: "Pusingan Seterusnya",
    posCurrent: "Semasa",
    aiThenPrefix: 'AI ketika itu: ',
    aiUnlinked: 'Tiada AI dipautkan',
    aiNotRecorded: 'Tidak direkod',
    insuranceLabel: "Insurans",
    insuranceNotSelected: 'Tidak dipilih',
    insuranceInactive: "Tidak berkuat kuasa",
    insuranceTypeNone: "Tidak berkuat kuasa",
    insuranceTypeEvent: "Insurans acara diaktifkan",
    insuranceTypeEventShort: "Insurans acara",
    insuranceTypeAi: "Insurans AI diaktifkan",
    insuranceTypeAiShort: "Insurans AI",
    insuranceTypeConverted: "Pesanan ini ditukar ke insurans acara",
    insuranceTypeUnknown: "Status insurans belum disahkan",
    inProgress: "Dalam proses",
    estimatedPnl: "Anggaran untung/rugi",
    settlementConfirming: "Sedang mengesahkan keputusan",
    balanceSyncing: "Menyegerak baki",
    pendingReview: "Menunggu semakan",
    connecting: "Menyambung...",
    connectWallet: "Sambung",
    orderDetail: {
      title: "Butiran pesanan",
      orderId: "ID pesanan",
      symbol: "Pasangan",
      interval: "Tempoh",
      direction: "Arah",
      aiDirection: "AI ketika itu",
      openTime: "Masa buka",
      settleTime: "Tamat tempoh",
      settledAt: "Masa selesai",
      openPrice: "Harga buka",
      closePrice: "Harga tutup",
      stake: "Pokok",
      premium: "Premium",
      netProfit: "Untung/rugi bersih",
      status: "Status",
      orderSource: "Sumber pesanan",
      converted: "Penukaran insurans",
      notRecorded: "Tidak direkod",
      copied: "ID pesanan disalin",
    },
    orderStatus: {
      CREATED: "Dicipta",
      ACCEPTED: "Diterima",
      CLOSED: "Ditutup",
      FUNDS_LOCKED: "Dana dikunci",
      AWAITING_SETTLEMENT: "Menunggu penyelesaian",
      PROCESSING: "Diproses",
    },
    insuranceBalanceInsufficient: "Baki akaun insurans tidak mencukupi",
    mainBalanceInsufficient: "Baki akaun utama tidak mencukupi",
    insuranceBalanceRequired: "Baki insurans tidak mencukupi; tidak boleh mengaktifkan insurans",
    insuranceRulesUnavailable: "Peraturan premium belum sedia; tidak boleh mengaktifkan insurans",
    insuranceMainRequired: "Baki akaun utama tidak mencukupi; tidak boleh mengaktifkan insurans",
    preferenceLoading: "Memuatkan tetapan insurans",
    preferenceLoadFailed: "Gagal memuatkan tetapan insurans; ketik untuk cuba lagi",
    preferenceSaveFailed: "Gagal menyimpan tetapan insurans; cuba lagi",
    preferenceSessionEndedSaveFailed: "Pusingan telah tamat, tetapi tetapan tutup tidak disimpan",
    premiumEstimate: "Anggaran premium {premium} JOULE (5-10%)",
    premiumShortfallHint: "Akaun insurans kekurangan {amount} JOULE",
    premiumEstimateUnavailable: "Premium belum dapat dianggarkan",
    premiumBoundEstimate: "Anggaran premium strategi terikat {premium} JOULE",
    insuranceConfirmTitle: "Sahkan premium",
    insuranceConfirmBody: "Pratonton premium {premium} JOULE. Pratonton adalah muktamad. Sahkan untuk serah.",
    actions: {
      rise: "Long",
      fall: "Short",
      buy: "Beli",
      sell: "Jual"
    },
    holdings: {
      current: "Posisi",
      history: "Sejarah Dagangan",
      currentCount: "Kedudukan terbuka {n}",
      empty: "Tiada posisi",
      historyEmpty: "Tiada sejarah"
    },
    position: {
      openPrice: "Harga Masuk",
      closePrice: "Harga Keluar",
      profitLoss: "U/R",
      countdown: "Penyelesaian dalam",
      calculating: "Mengira...",
      settled: "Diselesaikan",
      active: "Aktif",
      settledAt: "Diselesaikan pada",
      settling: "Settling"
    },
    modal: {
      amountPlaceholder: "Masukkan jumlah"
    },
    pairSelector: {
      title: "Pilih Pasangan",
      searchPlaceholder: "Cari syiling"
    },
    errors: {
      dataNotReady: "Memuatkan data, sila tunggu"
    },
    marketPause: {
      default: "Pasaran sementara tidak tersedia. Sila cuba lagi nanti.",
      lastPriceStreamWarming: "Suapan harga terkini sedang disediakan. Sila cuba sebentar lagi.",
      marketWarming: "Pasaran sedang disediakan. Sila cuba sebentar lagi.",
      recovering: "Pasaran sedang dipulihkan. Sila cuba sebentar lagi.",
      clockNotSynced: "Jam pelayan belum disegerakkan. Sila cuba sebentar lagi.",
      symbolUnavailable: "Pasangan dagangan ini belum dibuka"
    },
    toasts: {
      connectSuccess: "Berjaya disambungkan",
      connectCancelled: "Anda telah membatalkan sambungan",
      connectFailed: "Sambungan gagal"
    },
    openPriceLabel: "Harga buka",
    secondsUnit: "s",
    amountLabel: "Jumlah",
  },
  exchange: {
    title: "Tukar Segera",
    from: "Dari",
    to: "Ke",
    balance: "Baki",
    all: "Semua",
    placeholder: "Sila masukkan",
    fee: "Yuran",
    minAmount: "Jumlah tukaran minimum: {amount} {symbol}",
    button: "Tukar",
    tradeButton: "Dagangan",
    paymentCurrency: "Mata wang pembayaran",
    estimatedGasFee: "Anggaran yuran gas",
    gasPaymentNote: "Akan menggunakan baki GetGas untuk membayar yuran gas",
    slippage: "Gelinciran",
    auto: "Auto",
    approximately: "Kira-kira",
    minReceived: "Minimum diterima",
    exchangeRate: "Kadar pertukaran",
    finalAmount: "Jumlah akhir",
    confirm: "Sahkan",
    swapSuccess: "Tukar segera berjaya!",
    swapping: "Menukar...",
    confirmTitle: "Sahkan Tindakan",
    confirmContent: "Adakah anda pasti mahu meneruskan?",
    toasts: {
      fetchFailed: "Gagal mendapatkan aset",
      enterValidAmount: "Sila masukkan jumlah yang sah",
      minAmount: "Jumlah tukaran minimum ialah {amount} {symbol}",
      swapSuccess: "Tukar berjaya",
      requestFailed: "Permintaan gagal",
      insufficientBalance: "Baki tidak mencukupi, tidak dapat menukar",
      usdtRestricted: "USDT under review; exchange unavailable"
    },
    rateHint: "{usdt} USDT={joule}JOULE, no fee",
    configFee: "Yuran Joule → USDT {fee}",
    configLimits: "Yuran {fee} · Had nilai kasar {min}–{max} U",
    unlimited: "Tiada had",
    quoteFailed: "Tidak dapat dapatkan sebut harga, cuba lagi"
  },
  globalNode: {
    title: "Nod Global"
  },
  eventInsurance: {
    title: "Insurans Kontrak Acara",
    availableBalance: "Baki Tersedia (USDT)",
    fundTransfer: "Pemindahan Dana",
    fundHistory: "Sejarah Dana",
    type: "Jenis: ",
    all: "Semua",
    transfer: "Pemindahan",
    fundTransferTitle: "Pemindahan Dana",
    currency: "Mata Wang",
    from: "Dari",
    to: "Ke",
    availableAccount: "Akaun Tersedia",
    contractInsuranceAccount: "Akaun Insurans Kontrak",
    pleaseEnter: "Sila masukkan",
    confirmTransfer: "Sahkan Pemindahan",
    insufficientBalance: "Baki tidak mencukupi",
    transferSuccess: "Pemindahan berjaya",
    transferFailed: "Pemindahan gagal",
    transferring: "Memindahkan...",
    noRecords: "Tiada rekod",
    selectAccount: "Pilih akaun",
    cannotTransferToSameAccount: "Tidak boleh memindahkan ke akaun yang sama",
    cannotTransferContractAccount: "Pemindahan akaun kontrak tidak disokong",
    contractAccount: "Akaun kontrak (TAKER)",
    rulesTab: "Ringkasan",
    agreementTab: "Perjanjian penuh",
    insuranceRulesTitle: "Insurance Rules",
    preview: {
      eventGroup: "I. Peraturan ramalan kontrak acara",
      eventOpen: {
        title: "1. Insurance on",
        points: [
          "With insurance on, premium is based on order size vs account balance: ≤10% of balance → 15% premium; above → 20%.",
          "If the insurance account balance is insufficient, insurance does not take effect"
        ]
      },
      eventLimit: {
        title: "2. Order threshold",
        points: [
          "Max per order is 5,000 JOULE"
        ]
      },
      eventClaim: {
        title: "3. Compensation entitlement rules",
        ok: [
          "50% of compensation goes to personal airdrop quota; every 50 USD unlocks one computing node",
          "30% goes to community airdrop quota by VIP rules; every 50 USD unlocks one computing node"
        ],
        fail: [
          "Lose all stake principal; prediction ends"
        ]
      },
      eventPool: {
        title: "4. Event insurance pool payout:",
        points: [
          "Daily 2% of event insurance pool assets in PANTA is airdropped by node weight to eligible users",
          "When daily pool airdrops reach 50 USD in PANTA, one computing node is reduced"
        ]
      },
      eventProfit: {
        title: "5. P&L rules",
        points: [
          "Correct: receive principal 100% + profit (80%)",
          "Wrong: lose all stake principal; prediction ends"
        ]
      },
      aiGroup: "II. Peraturan ramalan AI",
      aiFirst: {
        title: "1. First order requires manual input"
      },
      aiOpen: {
        title: "2. Insurance on",
        points: [
          "With insurance on, pay 5%–10% of the position amount as premium",
          "If the insurance account balance is insufficient, insurance does not take effect"
        ]
      },
      aiLimit: {
        title: "3. Order limits",
        points: [
          "Amounts must follow the position table, and each direction must match the AI signal",
          "If not following the table, it becomes a normal event contract prediction",
          "Eight consecutive losses unlock the stated compensation entitlement",
          "A winning order resets the sequence to step 1"
        ]
      },
      table: {
        level: "Account level",
        order1: "Order 1",
        order2: "Order 2",
        order3: "Order 3",
        order4: "Order 4",
        order5: "Order 5",
        order6: "Order 6",
        order7: "Order 7",
        order8: "Order 8"
      },
      claimOk: "Eligible for compensation",
      claimFail: "Not eligible for compensation",
      claimFailWhen: "When not eligible:",
      claimPrereq: "Compensation prerequisites:",
      aiClaim: {
        title: "4. Compensation entitlement",
        prereq: [
          "Insurance enabled",
          "Direction matches AI signal",
          "Amount/order follows the table",
          "Full settlement conditions met"
        ],
        ok: [
          "Cash compensation = cumulative loss × 90%"
        ],
        fail: [
          "Lose all stake principal; prediction ends"
        ]
      },
      aiProfit: {
        title: "5. Profit rules",
        points: [
          "Correct: receive principal 100% + profit 80%",
          "Wrong: lose all stake principal; prediction ends or compensation applies"
        ]
      }
    },
    rulesContent: "PANTA Market Perjanjian Insurans Pelan Perlindungan Dagangan Kontrak Acara\n\n【Notis penting】Sebelum menggunakan perkhidmatan ini, sila baca dengan teliti dan fahami sepenuhnya keseluruhan kandungan perjanjian. Sistem akan menganggap pengguna menghidupkan 「Suis insurans」 sebagai anda telah membaca, memahami dan menerima perjanjian serta lampiran sepenuhnya, mengesahkan perjanjian mempunyai daya mengikat undang-undang, dan bersetuju mematuhi dengan ketat; jika tidak bersetuju dan tidak menerima, hentikan serta-merta penggunaan pelan perlindungan ini.\n\nPerkara 1: Peruntukan am dan skop permohonan\n\n1.1 Perjanjian ini menerangkan cara penyertaan, pembentukan pesanan, yuran, penentuan keputusan, penyelesaian dana, pampasan bersyarat dan hak nod berkaitan serta fungsi ramalan acara bagi dua fungsi 「Ramalan kontrak acara」 dan 「Ramalan kontrak acara AI」 dalam PANTA Market. Setiap produk menggunakan klausa khususnya; kadar, syarat pampasan atau peraturan nod satu produk tidak boleh digunakan terus pada produk lain.\n1.2 Ramalan kontrak acara ialah fungsi pengguna membuat pertimbangan terhadap acara yang disenaraikan terlebih dahulu dan hasil pilihannya, menggunakan JOULE untuk hantar dan mencipta pesanan. Kerugian layak akhir boleh, mengikut peraturan diluluskan, menjana had nod peribadi atau pasukan komuniti; had tersebut bukan pampasan tunai segera. Ramalan kontrak acara AI ialah fungsi pengguna merujuk isyarat arah ramalan AI sah yang disediakan sistem, mengesahkan penyertaan pesanan demi pesanan mengikut jumlah tetap dan susunan pelan terpilih untuk mencipta pesanan. Apabila 8 pesanan dalam urutan layak yang sama diselesaikan sepenuhnya dan semuanya rugi, serta memenuhi syarat jelas lain serentak, pampasan JOULE dikira 90% daripada jumlah prinsipal layak. Isyarat AI bukan jaminan keputusan, dan pampasan bersyarat tidak meliputi semua perbelanjaan.\n1.3 Perjanjian ini, parameter versi produk berkaitan, peraturan acara khusus dan halaman pengesahan pengguna membentuk peraturan lengkap. Halaman hanya boleh memaparkan parameter yang telah diluluskan, dan tidak boleh menggantikan kekurangan syarat utama dengan 「rujuk halaman」. Apabila dokumen bercanggah, transaksi baharu terjejas mesti dihentikan serta dijelaskan, disemak dan dibetulkan; tidak boleh kemudian memilih tafsiran kurang baik untuk pengguna secara unilateral untuk urus pesanan sedia ada.\n1.4 Projek ini melibatkan aset sebenar, ramalan acara, pampasan bersyarat dan istilah insurans, ganjaran pasukan, pertukaran dan kolam dana, dan bukan produk yang boleh melangkau semakan risiko dan pematuhan. Sifat undang-undang, lesen, wilayah perkhidmatan, kelayakan pengguna, AML, perlindungan pengguna dan keperluan pemprosesan data setiap fungsi mesti disahkan secara profesional mengikut skop perkhidmatan sebenar. Penafian tanggungjawab tidak menggantikan lesen perlu, susunan dana dan langkah kawalan; draf ini tidak mengandaikan undang-undang negara tertentu, dan tidak menentukan produk telah dibenarkan beroperasi secara sah.\n\nPerkara 2: Istilah dan status dana\n\n2.1 JOULE ialah unit ukuran prinsipal ramalan, premium insurans dan pampasan AI dalam reka bentuk produk ini; PANTA ialah unit aset untuk pengagihan hak nod dan operasi lain; setara USDT ialah asas ukuran sebahagian had dan pengiraan nilai. Ketiga-tiganya tidak boleh dicampur; paparan nombor dalaman tidak bermaksud boleh ditukar serta-merta kepada mata wang sah pada kadar tetap, dan tidak sama dengan pemindahan aset on-chain telah selesai; penjelasan ini tidak membatalkan hak aset atau obligasi bayaran yang telah terbentuk mengikut undang-undang dan kontrak.\n2.2 Prinsipal pesanan ialah jumlah JOULE yang pengguna sah mengesahkan dan sistem terima dalam pesanan itu, tidak termasuk premium. Premium ialah kos dikira mengikut peraturan terpakai pesanan itu. Jumlah beku biasanya jumlah prinsipal dan premium; jika ada kos lain mesti didedahkan berasingan terlebih dahulu, dan tidak boleh menambah caj tidak disahkan semasa penyelesaian.\n2.3 Baki tersedia ialah baki boleh digunakan untuk operasi baharu di bawah peraturan akaun semasa. Baki beku ialah yang diperuntukkan untuk pesanan diterima atau operasi diluluskan, sementara tidak boleh digunakan untuk operasi lain. Unjuran pulangan, pampasan menunggu semakan, had nod dan agihan belum dikreditkan tidak termasuk dalam baki tersedia. Paparan baki mesti nyatakan nama aset; tidak dibenarkan jumlahkan terus kuantiti aset berbeza.\n2.4 Urutan AI ialah rekod operasi bersambung dari pesanan ke-1 mengikut peraturan untuk pelan disahkan yang sama. Langkah semasa, keputusan pesanan dan bukti kelayakan diselenggara oleh pelayan. Putus rangkaian biasa atau keluar aplikasi bukan penamatan urutan; reset ialah menamatkan urutan lama selepas memenuhi syarat perjanjian ini.\n2.5 Had nod kuasa pengiraan ialah unit perakaunan setara USDT terkumpul mengikut peraturan daripada kerugian layak akhir, untuk menjana nod. Nod ialah rekod kelayakan menyertai pengagihan hak kemudian, bukan tunai segera atau PANTA dikreditkan, dan tidak menjadi NFT on-chain boleh dagang, stake atau pindah milik bebas hanya kerana namanya.\n2.6 Snapshot peraturan ialah versi peraturan, parameter, jumlah, asas harga, klausa dan bukti berkaitan disimpan semasa pengesahan pesanan atau urutan. Versi baharu tidak boleh menulis ganti snapshot lama. Rekod pelayan untuk semak status operasi, tetapi pengguna boleh beri bukti lain untuk mohon semakan semula; tidak boleh mengecualikan bantahan munasabah hanya kerana rekod disimpan platform.\n\nPerkara 3: Kelayakan penggunaan dan pengesahan perjanjian\n\n3.1 Platform hanya boleh sediakan fungsi berkaitan kepada pengguna dalam wilayah perkhidmatan, julat umur dan kesesuaian diluluskan. Versi rasmi mesti nyatakan keperluan pengesahan identiti, skop produk tersedia dan sebab sekatan. Tidak boleh anggap layak semua produk hanya kerana dompet disambung, antara muka kelihatan atau akaun ada baki.\n3.2 Pengguna mesti gunakan akaun dan aset di bawah kawalan sah sendiri; dilarang menyamar identiti, guna akaun orang lain tanpa kebenaran, palsukan dokumen kelayakan atau manipulasi isyarat atau bukti keputusan. Jika platform perlukan pengesahan tambahan, mesti terangkan dokumen diperlukan dan tujuan operasi; sekatan penyertaan baharu dan pelaksanaan pesanan sedia ada mesti dijelaskan berasingan.\n3.3 Sebelum pesanan, pengguna mesti boleh lihat prinsipal, premium, kos tambahan mungkin, pilihan ramalan, kerugian terburuk, syarat penyelesaian, sumber penentuan dan laluan pertikaian. Platform mesti sediakan langkah pengesahan jelas, dan tidak ganti pengesahan sebenar pengguna dengan persetujuan lalai, kos tersembunyi, tukar jumlah automatik atau desak ulang operasi.\n3.4 Isyarat AI, keputusan lepas, contoh pulangan, saiz kolam nod dan rekod hak orang lain bukan janji keputusan masa depan. Pengguna mungkin rugi prinsipal pesanan diterima dan premium berkaitan; hak nod juga boleh terjejas baki kolam, wajaran efektif, harga dan status pemprosesan. Pengguna tidak patut anggap contoh tertentu sebagai pulangan tetap atau tempoh pulangan pasti sendiri.\n\nPerkara 4: Peraturan ramalan kontrak acara\n\n4.1 Sebelum mula urutan AI, pengguna mesti lihat pelan tersedia, prinsipal posisi pelaksanaan, premium dijangka, keperluan dana jumlah, tempoh sah isyarat, peraturan penyelesaian 60 saat dan syarat pampasan 90%. Urutan baharu hanya boleh bermula dari pesanan ke-1; pelan tidak boleh ditukar semasa urutan; pengguna tidak boleh gabung langkau langkah, ubah jumlah atau pesanan belum selesai selari untuk bentuk urutan layak baharu. Selepas pilih keputusan acara dan masukkan prinsipal JOULE, platform kira premium mengikut asas posisi diluluskan. Reka bentuk semasa: prinsipal tidak melebihi 10% asas posisi, premium 15% prinsipal; melebihi 10%, 20%. Tepat pada sempadan 10% guna 15%.\n4.2 Isyarat AI mesti papar aset, arah, masa, tempoh sah dan nombor isyarat boleh dikenal pasti. Semasa pesanan, pengguna mesti sahkan arah sejajar isyarat sah pada masa itu. Isyarat dikemas kini semasa menunggu atau sambung semula mesti disemak semula; isyarat luput tidak boleh terus digunakan dari cache klien. Guna isyarat AI tidak bermaksud platform atau algoritma tahu keputusan masa depan. Ketepatan lepas, rekod demo dan penjelasan ramalan tidak boleh jamin keputusan pesanan ini. Platform tidak boleh guna ungkapan seperti 「menang pasti」, 「untung stabil」 atau 「salah pun tiada rugi」 menggantikan prinsipal, premium dan syarat pampasan sebenar.\n4.3 Setiap acara mesti senaraikan berasingan nama, penerangan fakta, hasil pilihan, masa buka dan tutup, zon waktu, had penyertaan, kriteria penentuan keputusan, sumber bukti utama dan sandaran, pengiraan untung, kerugian terburuk, peraturan batal atau tangguh dan prosedur rayuan. Untuk acara kabur, tiada kriteria penentuan atau parameter ekonomi utama belum diluluskan, tidak boleh buka pesanan sebenar. Semasa terima pesanan, platform mesti semak acara masih terbuka, masa pelayan sebelum tutup, pilihan dan versi sah, kelayakan dan had pengguna memenuhi, baki mencukupi. Penentuan tutup tidak rujuk masa peranti pengguna atau sama ada klien masih papar kira detik semasa klik.\n4.4 Selepas prinsipal dan premium berjaya dibeku dan pesanan diterima, platform pulangkan masa penerimaan dan titik penyelesaian dipersetujui. Titik itu dikira masa penerimaan pelayan tambah 60 saat, bukan dari buka halaman, terima isyarat atau klik butang. Kelewatan rangkaian tidak pendekkan atau panjangkan kriteria penentuan tetap. 60 saat menunjuk titik penentuan keputusan dipersetujui, tidak janji kredit dana saat kira detik klien sifar. Selepas titik dicapai, mesti dapat bukti keputusan dari sumber dipersetujui; tiada bukti, sumber anomali atau konflik keputusan, kekalkan menunggu penyelesaian dengan penjelasan, tidak boleh auto rekod rugi.\n4.5 Hanya apabila urutan sah semasa, peraturan dipapar jelas, tiada pesanan belum selesai, dan pengguna benar-benar hantar arah tidak sejajar isyarat sah atau jumlah tidak sejajar langkah tetap semasa, barulah guna reka bentuk tolak dan reset tamatkan urutan lama. Mesti papar sebab khusus, urutan terjejas dan tindakan seterusnya boleh laksana, serta simpan sejarah. Selepas reset, kali seterusnya boleh bina urutan baharu dari pesanan ke-1; tidak boleh sambung pesanan rugi urutan lama dengan urutan baharu untuk kira 8 kalah berturut. Untung rugi selesai urutan lama kekal, tidak auto dapat pampasan 90%; tidak halang pengguna mohon semakan semula atas ralat platform, reset salah atau pertikaian lain.\n4.6 Permintaan pelanggaran ditolak sendiri tidak laksana dan tidak cipta kerugian prinsipal, premium atau nod rugi baharu. Ungkapan dalam bahan asal tentang tukar kerugian pelanggaran ke nod belum bentuk peraturan boleh laksana; tidak boleh cipta rugi atau pampasan palsu untuk pesanan ditolak.\n4.7 Pengguna jeda mula langkah seterusnya tidak sama dengan 8 kalah berturut terbentuk; urutan tidak lengkap tidak boleh minta pampasan 90% mengikut nisbah bilangan pesanan rugi. Penamatan aktif urutan, keberadaan lama dan tempoh pemulihan perlukan pengesahan peraturan rasmi; tidak boleh tambah sendiri tempoh luput tidak didedahkan. Keluar biasa dan putus rangkaian tidak ditafsir sebagai pengunduran sukarela. Urutan sama mesti memenuhi empat syarat serentak untuk kira pampasan 90% JOULE mengikut reka bentuk semasa: setiap pesanan mekanisme insurans aktif dan prinsipal serta premium pesanan itu benar-benar dibeku; arah setiap pesanan sejajar isyarat AI sah semasa diterima; prinsipal dan susunan langkah setiap pesanan sejajar pelan disahkan; 8 pesanan diselesaikan sepenuhnya dan semua keputusan kerugian layak. Jumlah pampasan ialah jumlah prinsipal penyertaan 8 pesanan layak × 90%, diukur dan dibayar dalam JOULE; premium tidak masuk asas 90% itu. Pampasan tidak boleh diungkap terus sebagai pulangan 90% semua perbelanjaan, dan tidak auto ditukar USDT, tunai atau PANTA. Pertukaran aset lain masih perlukan peraturan dan kebenaran berasingan.\n4.8 Penubuhan kelayakan pampasan dan bayaran berjaya ialah dua fasa. Ada kelayakan tetapi dana tidak cukup, akaun anomali atau sekatan terpakai, kekalkan obligasi dan butiran menunggu bayaran, papar sedang proses atau sebab gantung jelas, kemudian urus mengikut undang-undang dan kontrak; tidak boleh tulis semula kesukaran bayaran sebagai pengguna tidak layak.\n4.9 Pampasan laksana sekali mengikut rekod unik urutan itu. Bayaran berjaya tetapi respons hilang, pertanyaan dan cuba semula kemudian mesti pulangkan keputusan asal tanpa bayaran berganda. Kegagalan bayaran mesti kekalkan status tidak lengkap sebenar; tidak boleh minta pengguna cipta urutan baharu atau pesanan semula untuk 「aktifkan」 pampasan asal. Jika urutan sama benarkan kadar berbeza setiap pesanan mengikut mekanisme pengesahan awal, mesti simpan snapshot setiap pesanan dan kumpul kos sebenar; tidak boleh guna satu kadar semasa kira semula semua pesanan lepas. Perubahan mekanisme kadar yang jejas urutan disahkan mesti tentukan skop dahulu; tidak boleh tambah kos retroaktif melalui halaman baharu.\n4.10 Unit minimum aset, ketepatan, kaedah pembundaran setiap pesanan dan pengendalian baki mesti ditetapkan sebelum pelancaran dan kekal konsisten. Pembundaran halaman untuk mudah baca tidak boleh ubah butiran perakaunan; ketepatan contoh pengiraan bukan ketepatan bayaran diluluskan. Yuran, spread dan baki tidak boleh disembunyikan paparan gabungan.\n\nPerkara 5: Perkhidmatan sistem\n\n5.1 Putus rangkaian atau tamat masa permintaan: pengguna semak pesanan asal dahulu, platform pulangkan status sebenar diterima, ditolak jelas atau masih menunggu pengesahan. Keputusan asal tidak diketahui tidak boleh desak bayaran berganda; hanya selepas pengesahan kemudian tidak diterima barulah sahkan permintaan baharu mengikut peraturan sah semasa.\n5.2 Isyarat atau sebut harga luput: tolak permintaan lama, papar sebab dan dapat semula kandungan. Tidak boleh ganti senyap arah, jumlah atau kos baharu, atau anggap luput auto reset pelanggaran AI. Jika permintaan lama sudah diterima, laksana mengikut snapshotnya.\n5.3 Keputusan atau harga anomali: ghentikan penentuan, penilaian atau agihan terjejas; sediakan status, skop terjejas dan saluran semakan. Keputusan hilang tidak boleh rekod rugi gagal; penilaian anomali tidak boleh besarkan asas kerugian. Tukar sumber sandaran mesti patuhi susunan sumber dan peraturan anomali diumumkan terlebih dahulu.\n5.4 Perbezaan perakaunan atau status transaksi luar tidak diketahui: semak rekod asal dan resit luar dahulu; jangan hantar semula tindakan tidak boleh balik. Selepas sahkan gagal, nyahbeku atau cuba semula mengikut peraturan; tidak diketahui tidak sama refund selesai. Tindakan dana pengguna selesai dan langkah beli syiling atau masuk kolam belum selesai mesti dipapar berasingan.\n5.5 Kekurangan dana: hentikan operasi baharu berkaitan yang boleh besarkan kekurangan, kekalkan obligasi terbentuk, maklum status menunggu, dan urus mengikut pelan diluluskan. Tidak boleh palsukan kredit, jadikan baki tersedia negatif atau tutup jurang dengan caj tambahan tidak dimaklumkan.\n5.6 Sekatan risiko: platform boleh buat pengesahan atau sekatan perlu mengikut peraturan diluluskan rasmi dan didedahkan secukupnya, tetapi mesti bezakan sekatan pesanan baharu, tangguh bayaran dan batal kelayakan. Sekatan tidak boleh auto tulis semula menang kalah lepas atau syarat ekonomi dipenuhi; pengecualian perlukan fakta dan asas, dengan saluran semakan semula tersedia.\n5.7 Semasa penyelenggaraan, henti perkhidmatan atau tutup produk, pesanan lepas, pampasan, pertikaian dan rekod boleh semak masih perlu ada susunan. Pengguna tidak boleh tambah transaksi baharu tidak bermaksud baki sedia ada, pampasan perlu bayar atau hak rayuan hilang. Matikan suis operasi baharu tidak patut tutup serentak semua semakan sejarah dan proses pelaksanaan.\n\nPerkara 6: Penafian tanggungjawab\n\nKehilangan disebabkan keadaan berikut, perkhidmatan tidak tanggung pampasan:\n6.1 Pengguna tidak patuhi strategi: sebarang tingkah laku menyimpang peraturan pengurusan posisi standard platform ini\n6.2 Keadaan pasaran melampau: kerugian akibat lumpuh bursa, kehabisan kecairan atau manipulasi pasaran\n6.3 Risiko sistem dan operasi: kerugian akibat rosak peranti pengguna, silap operasi atau akaun dicuri\n6.4 Risiko dasar dan pematuhan: gangguan atau larangan dagangan akibat perubahan undang-undang, peraturan atau perintah pengawalseliaan\n6.5 Risiko token intrinsik: penurunan atau runtuh nilai pasaran JOULE menjejaskan fungsi margin dan mata wang penyelesaian\n6.6 Penipuan dan tingkah laku berniat jahat: pengguna terlibat penipuan, pengubahan wang haram, manipulasi pasaran atau aktiviti haram lain\n6.7 Force majeure: kerosakan sistem platform ini akibat force majeure\n\nPerkara 7: Pendedahan risiko\n\nPengguna mengesahkan faham sepenuhnya dan terima risiko berikut:\n7.1 Tiada jaminan prinsipal atau untung: pelan ini hanya pampas sebahagian kerugian dan tidak mutlak jamin keselamatan prinsipal atau untung\n7.2 Risiko bergantung strategi: kesan perlindungan bergantung sepenuhnya pematuhan ketat strategi\n7.3 Risiko kecairan dan kunci: dana pampasan masuk akaun pengurusan kekayaan mungkin ada risiko pelaburan dan tempoh kunci, jejas kecairan\n7.4 Risiko pihak ketiga: risiko operasi, keselamatan dan turun naik nilai bursa bergantung\n7.5 Risiko ketidakpastian kawal selia: platform ini hadapi ketidakpastian kawal selia global dan risiko dihentikan\n7.6 Risiko keselamatan teknologi: termasuk risiko kehilangan aset akibat kelemahan smart contract, serangan hacker, dll.\n\nPerkara 8: Pindaan, penamatan dan pertikaian perjanjian\n\n8.1 Pindaan perjanjian: platform ini berhak semak perjanjian ini mengikut undang-undang atau keperluan operasi; perubahan material akan dimaklumkan melalui pengumuman platform\n8.2 Penamatan perjanjian: pengguna boleh matikan suis perlindungan bila-bila masa untuk tamatkan perkhidmatan; jika langgar perjanjian, platform boleh tamatkan secara sepihak; atas sebab undang-undang atau dasar pelan ini mungkin ditamatkan\n8.3 Penyelesaian pertikaian: pertikaian timbul dari perjanjian ini diselesaikan rundingan mesra; jika gagal, dirujuk ke badan timbang tara atau mahkamah ditetapkan\n\n【Pengesahan akhir】Anda faham dan bersetuju 「Hidupkan suis insurans」 ialah cara tunggal dan muktamad mengesahkan anda terikat keseluruhan kandungan perjanjian ini; sila buat keputusan berdasarkan pertimbangan bebas.",
    lockedBalance: "Non-transferable",
    equityTitle: "Event insurance equity",
    personalEquity: "Personal equity",
    teamEquity: "Team equity",
    equityNodes: "Active nodes",
    remainingEquity: "Remaining equity",
    peersPaid: "Peer paid",
    peersPending: "Peer pending",
    creditsCount: "Credit rows",
    nodeBatches: "Node batches",
    peerRows: "Pending peer rows",
    recentPayouts: "Recent payouts",
    premiumRules: "Position threshold {threshold}% · low premium {low}% · high premium {high}% (preview wins per order)",
    insuranceDeduction: "Insurance premium deduction (Event)",
    insurancePayout: "Insurance premium payout (Event)"
  },
  walletBind: {
    connectWallet: "Sambung",
    inputPlaceholder: "Masukkan alamat",
    bind: "Ikat",
    binding: "Mengikat",
    tip: "Petua: Jika sambungan dompet gagal, anda boleh cuba memasukkan alamat dompet secara manual untuk mengikat"
  },
  loginModal: {
    title: "Log Masuk PANTA MARKET",
    connectWallet: "Sambung",
    connecting: "Menyambung...",
    alreadyConnected: "Disambung",
    tip: "Petua: Jika sambungan dompet gagal, anda boleh cuba memasukkan alamat dompet secara manual untuk mengikat",
    inputLabel: "Masukkan alamat dompet",
    inputPlaceholder: "0x234d456f6798...",
    bind: "Ikat",
    binding: "Mengikat",
    bindSuccess: "Pengikatan berjaya",
    bindSuccessHint: "Pengikatan berjaya, sila log masuk semula",
    bindFailed: "Pengikatan gagal",
    noAuthCode: "Kod kebenaran hilang",
    invalidAddress: "Format alamat dompet tidak sah",
    confirmTitle: "Sahkan pengikatan",
    confirmWarning: "Sila sahkan dengan teliti bahawa alamat berikut adalah alamat dompet anda. Ia tidak boleh diubah selepas pengikatan",
    addressLabel: "Alamat dompet",
    cancel: "Batal",
    confirm: "Sahkan pengikatan",
    loginSuccess: "Log masuk berjaya",
    openWalletApp: "Buka {wallet}",
    openWalletConnect: "Buka {wallet} untuk sambung",
    openWalletSign: "Buka {wallet} untuk tandatangan",
    returnToBrowser: "Kembali ke sini selepas selesai",
    loginStepLabel: "Langkah {step}/2",
    stepConnectTitle: "Sambung dompet",
    stepConnectHint: "Luluskan sambungan dalam dompet anda, kemudian kembali ke sini",
    stepConnectHintWithOpen: "Ketik di bawah untuk buka dompet, luluskan sambungan, kemudian kembali",
    stepSignTitle: "Log masuk",
    stepSignHint: "Tandatangani mesej log masuk dalam dompet (tiada aset dipindah), kemudian kembali",
    stepSignHintWithOpen: "Satu langkah lagi: ketik di bawah untuk buka dompet dan tandatangani mesej log masuk",
    waitingWalletHintShort: "Jika tidak dibuka, ketik di bawah untuk buka dompet",
    retryLogin: "Cuba log masuk semula",
    networkRequired: "Tukar rangkaian",
    networkRequiredHint: "Tukar ke {chain}, kemudian kembali ke sini dan cuba lagi",
    switchingNetwork: "Sahkan penukaran rangkaian",
    switchingNetworkHint: "Luluskan penukaran ke {chain} dalam dompet anda",
    signatureRequired: "Tandatangan untuk log masuk",
    signatureHint: "Tandatangani dalam dompet — ini tidak memindahkan dana",
    verifyingLogin: "Mengesahkan",
    verifyingHint: "Sila tunggu",
    connectFailed: "Sambungan tidak lengkap, sila cuba lagi",

    waitingWalletReturn: "Sahkan dalam aplikasi dompet, kemudian kembali ke sini",
    waitingWalletHint: "Sahkan dalam dompet; anda akan kembali secara automatik"
  },
  walletProfile: {
    title: "Profil",
    address: "Alamat",
    accountName: "Nama Akaun",
    inviteCode: "Kod Jemputan",
    deactivateAccount: "Nyahaktifkan Akaun",
    logout: "Log Keluar",
    switchAccount: "Tukar Akaun",
    confirmLogout: "Adakah anda pasti mahu log keluar?",
    loggingOut: "Sedang log keluar...",
    confirmSwitch: "Adakah anda pasti mahu menukar akaun? Akaun semasa akan dilog keluar",
    developing: "Dalam Pembangunan",
    addressCopied: "Alamat Disalin",
    inviteCodeCopied: "Kod Jemputan Disalin"
  },
  aiPrediction: {
    stakeAutofill: "Bantuan AI",
    stakeAutofillWarning: "Hanya bantuan. Jumlah dicadangkan mungkin salah; semak sebelum buat pesanan. Autisi dijeda jika kependaman >800ms atau semakan sambungan gagal/tamat, dan diteruskan selepas pulih. Tidak menjejaskan pesanan manual.",
    stakeAutofillUnavailable: "Sambungan tidak stabil atau melebihi 800ms. Belum boleh diaktifkan.",
    stakeAutofillPaused: "Autisi dijeda: sambungan tidak stabil. Masukkan jumlah secara manual.",
    insuranceSyncing: "Menyegerakkan langkah insurans…",
    predictionBuffer: 'Menyediakan ramalan seterusnya',
    scheduleResultPending: 'Keputusan belum tersedia, mencuba semula',
    title: "Ramalan AI",
    bookingTitle: "Tempahan sesi AI",
    bookingExpand: "Kembangkan",
    bookingCollapse: "Runtuhkan",
    bookingNextSystem: "Sesi sistem seterusnya · SGT",
    bookingNextMine: "Tempahan seterusnya saya",
    bookingNone: "Tiada",
    bookingStartingSoon: "Sesi yang ditempah akan bermula tidak lama lagi",
    bookingToday: "Hari ini",
    bookingTomorrow: "Esok",
    bookingTimezone: "SGT",
    bookingQuota: "Baki sesi: {remaining}/{dailyLimit}",
    bookingSeats: "{occupied}/{capacity} tempat",
    bookingEmpty: "Tiada sesi tersedia",
    bookingWaiting: "Akan masuk automatik selepas operasi semasa selesai",
    bookingEnded: "Tamat",
    bookingJoin: "Sertai sesi",
    bookingReserve: "Tempah",
    bookingJoined: "Telah masuk",
    bookingReserved: "Ditempah",
    bookingFull: "Penuh",
    bookingConfirm: "Sahkan tempahan",
    bookingWarning: "Tempahan berjaya menggunakan 1 sesi hari itu; masih dikira jika tidak hadir.",
    bookingQuotaExhausted: "Had sesi hari ini telah habis",
    bookingUnavailable: "Tempahan tidak tersedia sekarang",
    bookingFailed: "Tempahan gagal. Muat semula dan cuba lagi.",
    aiPool: "Kolam AI",
    countdown: "Kira Detik",
    expectedProfit: "Keuntungan Dijangka",
    active: "Aktif",
    aiAnalysis: "Analisis Kebarangkalian Naik/Turun Pintar AI",
    updateTime: "Masa Kemas Kini",
    probabilityUp: "Kebarangkalian Naik",
    probabilityDown: "Kebarangkalian Turun",
    startPrediction: "Mula Ramalan",
    predicting: "Meramal...",
    stayOnPageHint: "Jangan keluar dari halaman ini, jika tidak hasil ramalan mungkin hilang.",
    userInfo: "Maklumat Pengguna",
    predictCount: "Kiraan Ramalan",
    freeCount: "Ramalan Percuma",
    openTime: "Buka pada: {time1}",
    up: "Naik",
    down: "Turun",
    notConnected: "Tidak Disambung",
    count: "Kiraan",
    learnMore: "Ketahui Lebih Lanjut",
    calculating: "Mengira...",
    settled: "Diselesaikan",
    loginFirst: "Sila log masuk dahulu",
    sessionSyncing: "Sedang menyegerakkan",
    actions: {
      rise: "Long",
      fall: "Short"
    },
    holdings: {
      current: "Posisi",
      history: "Sejarah",
      empty: "Tiada posisi",
      historyEmpty: "Tiada sejarah",
      aiHistory: "AI History",
      aiHistoryEmpty: "No AI history"
    },
    buyModal: {
      title: "Beli Keistimewaan",
      description: "Beli 30 Ramalan AI",
      upgradeAmount: "Jumlah Naik Taraf",
      balance: "Baki Tersedia",
      cancel: "Cancel",
      confirm: "Sahkan",
      purchasing: "Membeli...",
      purchaseSuccess: "Pembelian Berjaya",
      purchaseFailed: "Pembelian Gagal",
      dailyLimit: "You can purchase once per day."
    },
    noPredictionAlert: {
      title: "Ramalan AI Gagal",
      description: "Kiraan ramalan AI anda adalah 0. Anda tidak boleh menggunakan ramalan AI pada masa ini. Sila beli untuk meneruskan.",
      cancel: "Batal",
      confirm: "Beli Ramalan AI"
    },
    toasts: {
      predictionFailed: "Ramalan gagal",
      predictionSuccess: "Ramalan selesai",
      premiumShortfallReminder: "Full-round premium shortfall ~{amount} JOULE (reminder only; this order can still submit)",
      deferredWaitSettlement: "Signal ready; wait for the open position to settle before placing",
      insuranceTierUnavailable: "Insurance tier unavailable; try again later",
      insuranceCancelFailed: "Cannot close; unsettled orders may exist",
      resumeFailed: "Failed to resume prediction; try again later",
      requiredStakeInvalid: "Invalid prediction stake; start AI prediction again"
    },
    analyzing: "Menganalisis...",
    insurance: "Insurans",
    insuranceOn: "Aktif",
    insuranceOff: "Tidak aktif",
    aiLabel: "AI",
    lookLong: "Bullish",
    lookShort: "Bearish",
    waitingResult: "Waiting",
    startAIPrediction: "Start AI Prediction",
    scheduleConfirm: "Ikuti pusingan ini",
    scheduleBinding: "Mengikat isyarat...",
    predictionResult: "AI Prediction Result",
    nextRound: "Next Round",
    rise: "Long",
    fall: "Short",
    openPrice: "Harga buka",
    settledAt: "Diselesaikan pada",
    ordinaryInsuranceTitle: "Pesanan ini ialah insurans acara",
    ordinaryInsuranceBody: "Pesanan ini ialah insurans acara, bukan pembayaran pusingan AI. Premium mengikut pratonton selepas pengesahan.",
    sessionConflict: "Pusingan insurans AI masih aktif. Pulihkan atau tamatkan sebelum membuat insurans acara.",
    conversionTitle: "Tukar kepada insurans biasa?",
    conversionDesc: "Pesanan ini akan ditukar kepada insurans biasa dan menamatkan pusingan insurans AI. Kerugian berturut AI sebelumnya tidak dibayar. Premium biasa {premium} JOULE.",
    conversionConfirm: "Sahkan penukaran & pesan",
    stakeFromStrategy: "Saiz ditetapkan oleh strategi",
    stakeTier: "Peringkat {tier}",
    stakeStep: "Langkah {step}",
    selfQuotaRemaining: "Baki ramalan sendiri: {remaining}/{limit}",
    followRoundProgress: "Ikut AI · Pusingan {current}/{total}",
    followRoundsCompleted: "Ikut AI selesai · {current}/{total}",
    selfQuotaLoadingShort: "Memuatkan kuota…",
    selfQuotaLoginHint: "Log masuk untuk lihat kuota",
    selfQuotaLoading: "Kuota sedang dimuatkan, cuba lagi nanti",
    selfQuotaExhausted: "Kuota ramalan sendiri percuma hari ini habis; ramalan berbayar belum dibuka"
  },
  positionModal: {
    title: "Prediksi Harga",
    insurance: "Insurans",
    long: "Long",
    short: "Short",
    balance: "Baki",
    loading: "Memuatkan...",
    confirm: "Sahkan",
    processing: "Memproses pesanan...",
    success: "Pesanan berjaya dibuat!",
    insuranceOn: "Insurans diaktifkan",
    insuranceOff: "Insurans dimatikan",
    operationFailed: "Operasi gagal",
    balanceFetchFailed: "Gagal mendapatkan baki",
    minAmount: "Jumlah minimum ialah 0.1 TAKER",
    insufficientBalance: "Baki tidak mencukupi, baki semasa: {balance} TAKER",
    createFailed: "Gagal membuat posisi",
    recoverTitle: "Recover pending order",
    recoverContent: "Unconfirmed order found ({symbol} {direction} {amount}). Will reuse the original idempotency key without requoting.",
    recoverConfirm: "Recover",
    recoverCancel: "Cancel"
  },

  appeal: {
    title: "Bantuan Audit Aset",
    records: "Rekod Penghantaran",
    recordsTitle: "Rekod Penghantaran",
    noRecords: "Tiada rekod penghantaran",
    submitTime: "Masa Penghantaran",
    statusPending: "Menunggu",
    statusApproved: "Diluluskan",
    statusRejected: "Ditolak",
    failedReason: "Sebab Penolakan",
    uniLiveUid: "UniLive ID",
    uniLiveUidLoading: "Memuat...",
    walletAddress: "Alamat yang Terikat dengan PANTA MARKET",
    address: "Alamat",
    walletAddressPlaceholder: "Masukkan alamat log masuk PANTA MARKET",
    autoFill: "Isi Otomatis",
    depositAmount: "Jumlah Deposit",
    depositAmountPlaceholder: "Masukkan jumlah deposit",
    tokenType: "Jenis Token",
    selectToken: "Pilih token",
    tokens: {
      usdt: "USDT",
      taker: "JOULE"
    },
    transferTime: "Waktu Transfer",
    selectTime: "Pilih waktu transfer",
    timeRangeHint: "Data yang dihasilkan antara 5 Mac 2026 00:00 hingga 11 Mac 10:00 (SGT).",
    txHash: "HASH / TXID",
    txHashPlaceholder: "Masukkan hash transaksi",
    txHashHint: "Dapat diperiksa di penjelajah blockchain",
    uploadImages: "Tangkapan Layar Rekod Transfer",
    uploadHint: "Pilihan, muat naik sehingga 9 imej",
    addImage: "Tambah Imej",
    submit: "Hantar",
    submitting: "Menghantar...",
    submitSuccess: "Berjaya dihantar",
    submitFailed: "Penghantaran gagal, sila cuba lagi",
    uploadingImages: "Memuat naik imej...",
    uploadImagesFailed: "Gagal memuat naik imej",
    warningTitle: "Notis Penting",
    warningText: "Jika rekod yang dihantar berjaya disahkan, anda akan diberi ganjaran 5% kuasa langganan. Jika maklumat palsu diberikan, akaun akan dibekukan."
  },
  withdrawSheet: {
    title: "Keluarkan",
    balance: "Baki",
    processing: "Mengeluarkan TAKER...",
    success: "Pengeluaran TAKER berjaya!",
    withdrawing: " mengeluarkan...",
    withdrawSuccess: " Diserahkan untuk semakan",
    recordBadge: "Withdraw Record",
    sheetTitle: "Withdraw {token}",
    sheetDesc: "Enter the amount to withdraw. Minimum {min} USDT. No fees.",
    available: "Available {token}",
    amountPlaceholder: "Enter amount (min {min} USDT)"
  },
  depositSheet: {
    title: "Deposit JOULE",
    depositTo: "Deposit ke",
    spotAccount: "Akaun Spot",
    network: "Rangkaian",
    networkWarning: "Hanya deposit melalui rangkaian BSC/BEP20 disokong. Kerugian aset akibat penggunaan rangkaian lain tidak dapat dipulihkan.",
    depositAddress: "Alamat Deposit",
    address: "Alamat",
    depositTAKER: "Deposit JOULE",
    recharge: "Isi Semula",
    rechargeAddress: "Alamat Isi Semula",
    copy: "Salin",
    copySuccess: "Berjaya disalin",
    loadingAddress: "Mendapatkan alamat isi semula...",
    loadAddressFailed: "Gagal mendapatkan alamat isi semula",
    clickToRetry: "Klik untuk cuba lagi",
    saveAndShare: "Simpan & Kongsi Alamat",
    generating: "Menjana...",
    generateSuccess: "Berjaya dijana",
    generateFailed: "Gagal dijana",
    more: "Lagi",
    save: "Simpan",
    wechat: "WeChat",
    recordBadge: "Deposit Record",
    sheetDesc: "Deposit {token} from your wallet to platform balance",
    telegram: "Telegram",
    discord: "Discord",
    x: "X",
    savedImage: "Imej Disimpan",
    download: "Muat Turun",
    pleaseGenerate: "Sila jana imej terlebih dahulu",
    downloadSuccess: "Muat turun berjaya",
    saveSuccess: "Simpan berjaya",
    saveFailed: "Simpan gagal",
    needPermission: "Kebenaran diperlukan untuk menyimpan imej ke album",
    pleaseUseDapp: "Sila gunakan dompet untuk membuka operasi dapp",
    claimDesc: "Transfer USDT to the deposit address, then paste the tx hash to claim",
    claimButton: "Claim Deposit",
    environment: "Environment",
    txHash: "Transaction Hash",
    txHashPlaceholder: "Paste 0x transaction hash",
    optionalAmount: "Amount (optional note)"
  },
  sidebar: {
    loginAccount: "Log masuk akaun",
    inviteBanner: "Jemput rakan & dapatkan komisen pasukan",
    inviteCode: "Kod jemputan",
    defaultName: "PANTA MARKET",
    logoutWallet: "Disconnect Wallet"
  },
  teamDetails: {
    myReferrals: "Rujukan Saya",
    currentLevel: "Tahap Semasa: {level}",
    nextLevel: "Tahap Seterusnya",
    totalMembers: "Rujukan Langsung",
    validMembers: "Ahli Sah",
    teamLevel: "Tahap Pasukan: {level}",
    tradeTeam: "Pasukan Dagangan",
    financeTeam: "Pasukan Kewangan",
    teamMembers: "Ahli Pasukan",
    teamData: "Team Data",
    teamEarningsJoule: "Team Earnings (WATT)",
    myCurrentLevel: "My level: {level}",
    currentTotalPerf: "Total performance: {value}",
    currentAreaPerf: "Area performance: {value}",
    inviteDetails: "Invite details",
    startDate: "Start date",
    dateTo: "to",
    endDate: "End date",
    editRemark: "Edit note",
    addRemark: "Add note",
    viewDetail: "View details",
    status: "Status: ",
    time: "Time: ",
    level: "Level: ",
    inviteType: "Invite type: ",
    viewTeam: "View team",
    communityValidCount: "Community actives: ",
    communityTotalPerf: "Community volume: ",
    areaTotalPerf: "Area volume: ",
    yesterdayStake: "Yesterday stake: ",
    communityMaxLevel: "Community top level: ",
    personalEquity: "Personal equity: ",
    remarkPlaceholder: "Enter a note",
    saveRemark: "Update",
    filterAll: "All",
    filterDirect: "Direct",
    filterIndirect: "Indirect",
    viewingIndirect: "Rujukan terus {name}",
    teamPowerUsdt: "Team Power (USDT)",
    teamFlowJoule: "Team Volume (WATT)",
    statusInvalid: "Inactive",
    statusValid: "Active",
    peopleUnit: "{n}",
    remarkSaved: "Note saved"
  },
  teamMemberModal: {
    totalProfit: "Jumlah Keuntungan",
    totalFlow: "Jumlah Aliran",
    totalInvites: "Jumlah Jemputan",
    validMembers: "Jumlah Ahli Sah"
  },
  fundRecords: {
    feeLabel: "Fee: {fee}",
    withdrawTitle: "Withdraw Records",
    exchangeTitle: "Exchange Records",
    depositTitle: "Deposit Records"
  },
  aiAssistant: {
    title: "PANTA MARKET",
    newChat: "Sembang baharu",
    manual: "Manual",
    manualCardTitle: "Open operation manual",
    manualCardDesc: "Illustrated steps for deposit, exchange, transfer, and AI prediction",
    hello: "Hai, saya pembantu AI anda",
    hint: "Tanya analisis pasaran, lokasi peraturan insurans acara/AI, pasukan & jemputan, atau risiko.",
    placeholder: "Tanya sesuatu...",
    send: "Hantar",
    thinking: "Menganalisis...",
    disclaimer: "Untuk rujukan sahaja — bukan nasihat pelaburan.",
    bullish: "Bullish",
    bearish: "Bearish",
    aiAnalysis: "Ringkasan AI",
    strategy: "Strategi dagangan",
    reasoning: "Penaakulan",
    targetPrice: "Sasaran {price}",
    stopLoss: "Stop {price}",
    takeProfit: "Take profit {price}",
    dirLong: "Long",
    dirShort: "Short",
    dirNeutral: "Neutral",
    analysisDone: "Analisis {symbol} ({timeframe}) siap. Lihat kad di bawah.",
    analysisBtc: "Analisis BTC jangka pendek.",
    analysisEth: "Analisis ETH julat.",
    analysisRisk: "Bacaan risiko pasaran.",
    suggestions: {
      btc1m: "Analisis outlook BTCUSDT 1m",
      ethTrend: "Patut kejar ETH atau tunggu?",
      marketRisk: "Selera risiko pasaran semasa?",
      eventRules: "Di mana lihat pratonton peraturan insurans kontrak acara?",
      aiRules: "Bagaimana faham peraturan/peringkat AI?",
      teamWhere: "Di mana lihat butiran pasukan?",
      inviteWhere: "Di mana pautan jemputan / ikat atasan?"
    },
    guides: {
      eventRules: "Peraturan insurans acara: buka Event Contract, ketik pintu peraturan di sebelah suis insurans. Pratonton untuk premium/had/faedah; Perjanjian penuh untuk teks rasmi.",
      aiRules: "AI Prediction: tab tengah → AI Prediction. Semak countdown pusingan seterusnya, peringkat/langkah insurans, kuota ramalan kendiri. Peraturan dalam helaian insurans yang sama. Pesanan mesti padan saiz peringkat dan arah.",
      teamWhere: "Butiran pasukan: bar sisi atau Saya → Pasukan saya. Tukar hasil dagangan/kewangan, ketik Butiran pasukan untuk rujukan terus, volum, tahap, ahli.",
      inviteWhere: "Jemput & ikat: bar sisi/Saya → Jemput rakan untuk salin pautan (?ref=). Jika belum ikat atasan, modal muncul selepas log masuk. Tanpa param jemputan, medan dipraisi alamat lalai sistem."
    },
    generic: {
      a: "Faham. Tanya pasaran, lokasi peraturan acara/AI, pasukan & jemputan, atau ketik prompt pantas.",
      b: "OK. Kad outlook dan panduan ciri.",
      c: "Cuba prompt peraturan acara, peraturan AI, butiran pasukan, atau pautan jemputan."
    }
  },
  createMarket: {
    title: "Create Market",
    saveDraft: "Save Draft",
    marketTitle: "Market Title",
    titlePlaceholder: "Enter market title",
    category: "Category",
    secondaryOptional: "Secondary (opt.)",
    deadline: "Deadline",
    optionsTitle: "Outcomes (2–16)",
    optionsSub: "Name each option",
    resetDefault: "Reset",
    addOption: "+ Add Option",
    ratioHint: "Initial ratio: leave blank to split evenly; if filled, each option needs an integer 1–99 and the total must be 100.",
    rulesSection: "Rules / Settlement Source",
    rulesSectionSub: "Optional — shown in the rules & settlement popup on the detail page",
    rulesLabel: "Rules",
    rulesPlaceholder: "Settlement criteria, edge cases, etc.",
    settleLabel: "Settlement Source",
    settlePlaceholder: "Official site / news / URL",
    liquidityTitle: "Initial Liquidity",
    liquiditySub: "Funds needed to bootstrap the market",
    enabled: "On",
    disabled: "Off",
    investAmount: "Amount (JOULE)",
    balance: "Balance: {n}",
    max: "Max",
    initialLiquidity: "Initial Liquidity",
    marginRefund: "Margin (refunded after settlement)",
    totalTip: "Margin matches liquidity 1:1 and is fully refunded when the event settles or is canceled.",
    totalDeduct: "Total Deduct",
    feeTip: "Tip: you earn a 0.5% creator fee on every trade in this market.",
    accessPassword: "Access Password",
    accessPasswordSub: "The event will show a lock. Only people with the share link or password can enter.",
    passwordPlaceholder: "Set password (4–20 chars)",
    hide: "Hide",
    show: "Show",
    cardPreview: "Card Preview",
    deadlinePrefix: "Ends {date}",
    submitting: "Creating...",
    submit: "Confirm & Add Liquidity",
    createSuccess: "Created",
    creating: "Creating",
    creatingDesc: "Please wait while we submit the market…",
    backHome: "Home",
    createAnother: "Create Another",
    deadlineShort: "{m}/{d}",
    yes: "Yes",
    no: "No",
    optionN: "Option {n}",
    draftSaved: "Draft saved",
    draftSaveFailed: "Failed to save draft",
    resetDone: "Reset to defaults",
    maxOptions: "Up to 16 options",
    minOptions: "Keep at least 2 options",
    needMinOptions: "Need at least 2 options",
    fillOptionName: "Enter a name for option {n}",
    fillAllPercents: "Fill a ratio for every option",
    percentRange: "Ratios must be integers 1–99",
    percentSum: "Ratios must sum to 100 (now {sum})",
    enterTitle: "Enter a market title",
    enterAmount: "Enter an amount",
    insufficientBalance: "Insufficient balance (incl. margin)",
    passwordLength: "Password must be 4–20 characters",
    deadlineFuture: "Deadline must be in the future",
    completeForm: "Please complete the form",
    createdMsg: "“{title}” created. Ends {date} {time}"
  },
  marketDetail: {
    tabTrades: "Dagangan terkini",
    tabLp: "LP",
    tabPositions: "Posisi",
    tabRules: "Peraturan",
    colAddress: "Alamat",
    colTime: "Masa",
    colType: "Jenis",
    colVolumePrice: "Saiz/Harga",
    colTurnover: "Nilai",
    typeBuy: "Beli",
    typeSell: "Jual",
    empty: "Tiada data",
    share: "Kongsi",
    rulesBody: "Pasaran ini ramalan peristiwa binari. Buku pesanan mungkin dikunci sebelum penyelesaian; selepas keputusan diumum, diselesaikan mengikut pegangan. Sila berhati-hati terhadap risiko.",
    priceJoule: "Harga (JOULE)",
    investJoule: "Pelaburan (JOULE)",
    totalLiquidity: "Kecairan",
    dealPrice: "Harga isi",
    estProfit: "Untung anggaran",
    jouleBalance: "Baki JOULE: {n}",
    positionCount: "Bil. posisi: {n}",
    max: "Maks",
    confirmOrder: "Sahkan pesanan",
    ordering: "Menghantar...",
    enterAmount: "Masukkan jumlah",
    invalidPrice: "Harga tidak sah",
    amountExceed: "Melebihi baki",
    orderSuccess: "Pesanan berjaya",
    poolSize: "Saiz kolam",
    colBalance: "Baki",
    shares: "{n} unit",
    rulesTitle: "Peraturan",
    rulesValue: "Tiada penerangan",
    settleSource: "Sumber penyelesaian",
    settleValue: "Tiada penerangan"
  },
  rank: {
    applyTitle: "Become an Expert",
    applyDesc: "Show your trading talent and earn revenue share",
    applyCta: "Join Now",
    tabExpert: "Expert Ranking",
    tabMaker: "Market Maker",
    tabWinRate: "Win Rate",
    tabProfit: "Profit",
    experts: {
      trendCatcher: "Trend Catcher",
      whaleWatcher: "Whale Watcher",
      cryptoWolf: "Crypto Wolf",
      swingCaptain: "Swing Captain",
      arbHunter: "Arb Hunter",
      bullKnight: "Bull Knight"
    },
    tagPolitics: "Politics",
    tagEsports: "Esports",
    comingSoon: "Coming soon"
  },
  operationManual: {
    title: "Operation Manual",
    docTitle: "PANTA MARKET Operation Manual",
    sourceHint: "Illustrated steps adapted from the official manual. Tap screenshots to zoom."
  },
  pantaMarket: {
    title: "Panta Market",
    tokenSection: "Token tadbir urus PANTA",
    todayBurn: "Dibakar hari ini",
    totalBurn: "Jumlah dibakar",
    burned: "Telah dibakar",
    initialSupply: "Terbitan awal",
    maxSupply: "Terbitan maksimum",
    finalCirculation: "Edaran akhir",
    contractAddress: "Kontrak: ",
    copied: "Disalin",
    ecoSection: "PANTA · Ekosistem AI",
    ecoTabs: {
      market: "Analisis pasaran",
      arbitrage: "Alat arbitraj",
      acquisition: "Pengambilan global",
      video: "Penciptaan video"
    },
    apps: {
      pantaAi: "Panta AI",
      asiStar: "ASI Star",
      tatianaTv: "Tatiana TV",
      tokenSpace: "Token space"
    },
    groupSection: "PANTA · Kumpulan kreatif",
    groupTabs: {
      recommend: "Untuk anda",
      hot: "Popular",
      ipDrama: "Drama IP",
      ipCollab: "Kolaborasi IP",
      data: "Data"
    },
    filters: {
      all: "Semua",
      new: "Keluaran baharu",
      ending: "Hampir tamat",
      highScore: "Skor AI tinggi"
    },
    project: {
      badge: "Tayangan Perdana Planet",
      title: "《Panta AI · Kebangkitan》 Animasi pendek AI",
      score: "Skor AI 92",
      tagDrama: "Drama IP",
      tagRights: "Hak #0001",
      desc: "Panta AI bantu saya berbalik arah — drama pendek tutorial app AI"
    },
    values: {
      todayBurn: "321",
      totalBurn: "4,212",
      initialSupply: "10M",
      maxSupply: "210M",
      finalCirculation: "21M"
    }
  },
  copyTrade: {
    menuTitle: "Copy Trading",
    pageTitle: "Copy Trading",
    fallback: "Operasi gagal. Sila cuba lagi kemudian.",
    pauseRule: "Jika masih dijeda apabila penyelesaian minggu ini selesai, hubungan copy akan dibatalkan secara automatik minggu depan.",
    pauseSuccess: "Berjaya dijeda",
    resumeSuccess: "Disambung semula",
    endSuccess: "Ditamatkan",
    followSuccess: "Copy dimulakan",
    pendingReviewToast: "Menunggu semakan pedagang",
    savedSuccess: "Disimpan",
    registerSuccess: "Berdaftar. Deposit dibekukan.",
    cancelRequested: "Pembatalan diminta",
    cancelWithdrawn: "Pembatalan ditarik balik",
    kickedSuccess: "Dialih keluar",
    approvedSuccess: "Diluluskan",
    rejectedSuccess: "Ditolak",
    filledToForm: "Diisi ke borang follow",
    traderNotFound: {
      search: "Pedagang tidak dijumpai. Semak alamat dompet, atau mereka mungkin belum mengaktifkan copy trading.",
      business: "Pedagang ini tidak tersedia buat masa ini"
    },
    tabs: {
      board: "Papan Kedudukan",
      follows: "Follow saya",
      join: "Follow",
      trader: "Lead",
      apps: "Permohonan",
      fans: "Pengikut",
      rules: "Peraturan",
      settings: "Peraturan",
      follow: "Follow"
    },
    ui: {
      refresh: "Muat semula",
      search: "Cari",
      loginWallet: "Sambung dompet",
      needLoginAction: "Tindakan ini memerlukan log masuk dompet, sama seperti membuat pesanan.",
      needLoginTrader: "API pedagang memerlukan log masuk.",
      loginToView: "Log masuk untuk lihat",
      loading: "Memuatkan…",
      empty: "Tiada",
      readonly: "baca sahaja",
      yes: "Ya",
      no: "Tidak",
      immediate: "berkuat kuasa serta-merta",
      current: "Semasa",
      nextWeek: "Minggu depan",
      pause: "Jeda",
      resume: "Sambung",
      end: "Tamat",
      save: "Simpan",
      kick: "Alih keluar",
      approve: "Lulus",
      reject: "Tolak",
      requestCancel: "Mohon pembatalan",
      withdrawCancel: "Tarik balik pembatalan",
      confirmFollow: "Sahkan follow",
      registerWithDeposit: "Bekukan deposit & daftar",
      registerConfirmTitle: "Sahkan pendaftaran",
      registerFreezeConfirm: "{amount} JOULE margin akan dibekukan dalam akaun dagangan.",
      platformSettings: "Tetapan platform",
      settingsTip: "Hanya pesanan lead biasa yang diinsuranskan disalin. Pesanan biasa tanpa insurans dan pesanan AI tidak disalin, dan pesanan COPY yang dijana tidak lead salinan lanjut. Pedagang menggunakan API pesanan sedia ada dan tidak boleh hantar orderSource. Pengikut melihat pesanan COPY dalam senarai pesanan. Amaun dipaparkan 2 perpuluhan; digit extra dipotong.",
      deposit: "Deposit",
      depositFreezeWeeks: "Minggu pembekuan deposit",
      maxFollowers: "Had pengikut",
      shareRateRange: "Julat kadar kongsi",
      shareRateDefault: "Kadar kongsi lalai",
      shareRateNextWeek: "Kadar kongsi berkuat kuasa minggu depan",
      pendingShareHint: "Berkuat kuasa Isnin depan: {rate}",
      pendingMaxFollowersHint: "Berkuat kuasa Isnin depan: {n}",
      depositFrozenShort: "Masih beku",
      minFollowStake: "Stake follow minimum",
      ratioRange: "Julat nisbah",
      maxSimultaneousFollows: "Follow serentak maksimum",
      defaultReview: "Semakan lalai",
      defaultMinBalance: "Ambang baki lalai",
      settlementTimezone: "Zon waktu penyelesaian",
      leaderboardMeta: "Min papan / saiz",
      leaderboardMetaValue: "{min} pesanan / {size} baris",
      weekLeaderboard: "Papan kadar menang minggu ini",
      expertLeaderboard: "Papan kedudukan pedagang",
      heroTitle: "Jadi pedagang lead",
      heroDesc: "Mula lead dagangan dan dapatkan kongsi untung",
      heroActiveTitle: "Anda pedagang lead",
      heroActiveDesc: "Status pedagang lead anda aktif",
      heroRegister: "Daftar",
      heroSettings: "Tetapan lead",
      myLeading: "Lead saya",
      winRateBoard: "Kadar menang",
      pnlBoard: "Untung",
      searchAddress: "Cari alamat",
      searchNicknameOrAddress: "Cari nama panggilan atau alamat",
      searchQueryTooShort: "Masukkan sekurang-kurangnya 2 aksara",
      winRateShort: "Kadar menang",
      followersLabel: "Pengikut:",
      shareRateLabel: "Kadar kongsi:",
      roundPnlLabel: "PnL pusingan:",
      settledOrders: "{n} diselesaikan",
      activeCount: "Sedang berjalan",
      followStatsShort: "Pool {pool} · Ditahan {cash}",
      traderSettings: "Tetapan lead",
      confirmChanges: "Sahkan perubahan",
      confirmCancel: "Sahkan pembatalan",
      cancelModalTitle: "Notis pembatalan",
      activeInProgress: "Sedang berjalan",
      leadingFollowerCount: "Pengikut {n}",
      auditApps: "Permohonan {n}",
      leaderboardNote: "Hanya mengira pesanan biasa diinsuranskan menang/kalah yang diselesaikan minggu ini, selepas bilangan pesanan minimum. Bukan kadar menang sepanjang masa atau AI. Nama pasukan dan jumlah follow terkumpul tidak disediakan.",
      weekStart: "Permulaan minggu (Isn): {date}",
      leaderboardEmpty: "Tiada pedagang dalam senarai lagi. Cari alamat penuh untuk follow.",
      winRate: "Menang {n}%",
      boardSub: "Kongsi {share} · Pengikut {followers}/{max} · Diselesaikan {orders} · PnL minggu {pnl} JOULE",
      searchTrader: "Cari pedagang",
      walletPlaceholder: "Alamat dompet penuh 0x…",
      address: "Alamat",
      status: "Status",
      shareRate: "Kadar kongsi",
      review: "Semakan",
      minBalance: "Ambang baki",
      followerCount: "Pengikut",
      startFollow: "Mula follow",
      traderWallet: "Alamat pedagang",
      followMode: "Mod follow",
      ratioLabel: "Nisbah (%), julat {min} ~ {max}",
      insuranceMode: "Mod insurans",
      takeProfit: "Take profit (JOULE, pilihan)",
      stopLoss: "Stop loss (JOULE, pilihan)",
      takeProfitPh: "Jeda apabila PnL bersih mingguan capai ini",
      stopLossPh: "Jeda apabila kerugian bersih mingguan capai ini",
      followHint: "Anda boleh follow maksimum {n} pedagang serentak. Pada had, follow pedagang baru akan tamatkan hubungan semasa dahulu — bukan pratonton tanpa kesan. Untuk ubah parameter, tamatkan dan follow semula.",
      endConfirm:
        "Tamatkan hubungan copy trading dengan pedagang ini? Anda akan berhenti mengikuti isyarat mereka. Pesanan sejarah dan PnL yang telah diselesaikan tidak terjejas.",
      weeklyPoolHint: "Pool adalah pool minggu ini, bukan jumlah follow terkumpul. Hubungan tamat dan permohonan menunggu tidak ada dalam senarai ini.",
      networkUnclear: "Keputusan tidak disahkan. Muat semula dan semak hubungan semasa atau profil pedagang sebelum cuba lagi.",
      myFollows: "Follow saya",
      noFollows: "Tiada hubungan follow",
      followSub: "{mode}{ratio} · {insurance} · Kongsi dikunci {share}",
      followStats: "PnL minggu {pnl} · Pool {pool} · Ditahan {cash}",
      pauseReason: "Sebab jeda: {reason}",
      registerTrader: "Daftar sebagai pedagang",
      registerHint: "Pendaftaran: bayar {amount} JOULE sebagai deposit pedagang lead (dibekukan semasa aktif; dikembalikan selepas semakan pembatalan). Satu identiti pedagang setiap dompet.",
      registerBalanceHint: "Selepas membekukan deposit {deposit} JOULE, baki tersedia masih mesti ≥ {remain} JOULE.",
      shareRateInput: "Kadar kongsi (%) julat {min} ~ {max}; perubahan berkuat kuasa kitaran seterusnya.",
      maxFollowersInput: "Had pengikut (≤ {max})",
      reviewMode: "Kaedah kelulusan",
      minBalanceInput: "Ambang baki pengikut · pilihan (JOULE)",
      myTrader: "Profil pedagang saya",
      depositHeld: "{amount} / dibekukan {held}",
      currentFollowers: "Pengikut semasa",
      cancelEffective: "Pembatalan berkuat kuasa pada",
      depositRelease: "Pelepasan deposit pada",
      editParams: "Edit tetapan",
      editHint: "Kongsi / had berkuat kuasa minggu depan; semakan dan ambang serta-merta. Kunci penyelesaian Ahad 22:00 hingga sebelum Isn 01:00 (SGT). Percayai pelayan; jangan sambung edit pada Isn 00:00 sendiri.",
      shareRatePercent: "Kadar kongsi (%)",
      minBalanceJoule: "Ambang baki (JOULE)",
      cancelTip: "Selepas pembatalan anda masih lead minggu ini; identiti tamat Isn depan 00:00; deposit kekal dibekukan seminggu lagi kemudian dikembalikan. Boleh tarik balik sebelum berkuat kuasa.",
      followers: "Pengikut",
      followerSub: "{mode}{ratio} · PnL minggu {pnl} · Ditahan {cash}",
      applications: "Permohonan menunggu",
      noApplications: "Tiada permohonan",
      fillForm: "Isi borang follow",
      needTraderFirst: "Daftar sebagai pedagang dahulu",
      cancelRequestedAt: "Pembatalan diminta pada",
      ratioRangeInvalid: "Nisbah mesti antara {min} dan {max}",
      shareRangeInvalid: "Kadar kongsi mesti antara {min} dan {max}",
      maxFollowersInvalid: "Had pengikut tidak boleh melebihi {max}",
      needShareRate: "Masukkan kadar kongsi",
      needMaxFollowers: "Masukkan had pengikut",
      needRatio: "Masukkan nisbah",
      badTakeProfit: "Amaun take profit tidak sah",
      badStopLoss: "Amaun stop loss tidak sah",
      badMinBalance: "Ambang baki tidak sah",
      insuranceShortFollow: "Follow",
      insuranceShortOn: "Sentiasa hidup",
      insuranceShortOff: "Sentiasa mati",
      symbolSettings: "Tetapan simbol copy",
      symbolPickHint: "semua mati secara lalai; hidupkan manual, boleh edit bila-bila",
      followSymbolHint: "Pilih daripada simbol yang dibenarkan pedagang ini. Hidupkan sekurang-kurangnya satu.",
      followSymbolWait: "Cari pedagang dahulu, kemudian pilih simbol untuk follow.",
      symbolNeedOne: "Hidupkan sekurang-kurangnya satu simbol",
      symbolNotAllowed: "Simbol terpilih tidak dibenarkan oleh pedagang ini",
      effectiveSymbols: "Berkesan",
      editSymbols: "Edit simbol",
      allowedSymbols: "Simbol terbuka",
      weekPnlLabel: "PnL minggu:",
      currentNetPnlLabel: "Current Net PnL",
      categoryCrypto: "Kripto",
      categoryCommodity: "Komoditi",
      categoryEquity: "Ekuiti",
      symbolListCol: "Senarai",
      symbolLeadCol: "Lead",
      symbolFollowCol: "Follow",
      symbolTags: "Terbuka",
      leadingSymbols: "Simbol lead",
      detail: "Butiran",
      enabled: "Hidup",
      disabled: "Mati",
      held: "Terbuka",
      notHeld: "Ditutup",
      weekSettledOrders: "Diselesaikan minggu ini",
      historicalNetPnl: "PnL sepanjang masa",
      copyTotalPnl: "Jumlah PnL copy",
      historicalSharePayout: "Bayaran kongsi",
      allOrders: "Semua",
      prevPage: "Prev",
      nextPage: "Next",
      pageOf: "{page} / {totalPages}",
      jumpToPage: "Go to",
      jumpConfirm: "Go",
      openOrders: "Terbuka",
      settledOrdersTab: "Diselesaikan",
      colInterval: "Tempoh",
      colOrderTime: "Masa pesanan",
      colSelfPnl: "PnL sendiri (termasuk premium)",
      colEstShare: "Kongsi anggaran (JOULE)",
      traderOrdersTitle: "Pesanan lead {symbol}",
      followOrdersTitle: "Pesanan copy {symbol}",
      selfPnl: "PnL sendiri",
      estimatedShare: "Kongsi anggaran",
      inProgress: "Sedang berjalan",
      followAssets: "PnL mengikut aset",
      byAsset: "Mengikut aset",
      followHistory: "Tamat",
      followStartTime: "Mula: ",
      followEndTime: "Tamat: ",
      myPendingApps: "Menunggu",
      cashHeldHint: "Kongsi anggaran ditahan minggu ini {cash} JOULE",
      cashHeldFrozen: "Potongan kongsi anggaran pusingan ini: {cash} (JOULE, dibekukan)",
      followedTrader: "Pedagang",
      followInfo: "Maklumat follow",
      totalPnlJoule: "Jumlah PnL (JOULE)",
      colTrader: "Pedagang",
      colPrincipal: "Modal",
      colPnlShare: "PnL (termasuk premium) / kongsi (JOULE)",
      traderInfo: "Profil pedagang",
      traderNotFound: "Pedagang tidak dijumpai",
      followSettingsRelationHint: "Mod follow, insurans dan TP/SL diguna untuk keseluruhan hubungan bagi semua simbol dipilih. Anda boleh ubah bila-bila dalam Tetapan follow.",
      followSettingsPrepareHint: "Selepas sahkan, konfigurasi follow ini digunakan untuk semua simbol yang dipilih.",
      followOptions: "Pilihan follow",
      noFollowOptions: "Tiada pilihan follow~",
      symbolFollowing: "Mengfollow",
      symbolPaused: "Dijeda",
      symbolIdle: "Tidak follow",
      cancelFollowSymbol: "Berhenti follow",
      cancelSymbolConfirm: "Berhenti follow {symbol}?",
      cancelLastSymbolConfirm: "Ini simbol terakhir. Berhenti follow akan tamatkan keseluruhan hubungan. Teruskan?",
      followNow: "Follow sekarang",
      followAll: "Follow",
      unfollowAll: "Batal follow",
      unfollowAllConfirm: "Berhenti follow semua simbol pedagang ini? Ini akan tamatkan keseluruhan hubungan copy.",
      followSettings: "Tetapan follow",
      goFollowSettings: "Buka ›",
      copyAccountBalance: "Akaun copy: {amount} JOULE",
      orderFollowerCount: "Pengikut pada order ini",
      copyingStatus: "Sedang copy",
      roleStatusLeading: "Sedang lead",
      roleStatusFollowing: "Sedang copy",
      roleStatusPaused: "Copy digantung",
      copyOrderTag: "Copy",
      copyOpenPositions: "Kedudukan copy terbuka",
      copyInsuredOrdinary: "Insurans biasa aktif",
      copyUninsured: "Tiada insurans",
      addSymbolHint: "Simbol ini akan ditambah ke follow semasa anda.",
      myRelationStatus: "Follow saya",
      latestSettlements: "Penyelesaian terkini",
      resumeRelationFirst: "Hubungan dijeda sepenuhnya. Sambung semula dalam Follow Saya sebelum tindakan per simbol.",
      resumeStopLossHint: "Current weekly loss is {amount}. Set stop-loss above {amount} to resume copying.",
      resumeTakeProfitHint: "Current weekly profit is {amount}. Set take-profit above {amount} to resume copying.",
      resumeStartFollow: "Start following",
      colType: "Jenis",
      colPnlJoule: "PnL (JOULE)",
      tpSl: "Take profit / stop loss",
      takeProfitPhFull: "Jeda selepas untung bersih mingguan capai — pilihan (JOULE)",
      stopLossPhFull: "Jeda selepas kerugian bersih mingguan capai — pilihan (JOULE)",
      confirmModify: "Sahkan",
      clearSearch: "Kembali ke papan",
      searchResultHint: "Hasil carian (ketik untuk buka profil pedagang)",
      searchEmpty: "Pedagang tidak dijumpai",
      noMoreSettlements: "Tiada lagi"
    },
    errors: {
      AUTH_REQUIRED: "Sila sambung dompet dahulu",
      AUTH_UNAVAILABLE: "Perkhidmatan log masuk tidak tersedia buat sementara. Sila cuba lagi.",
      POSTGRES_REQUIRED: "Perkhidmatan tidak tersedia buat sementara. Sila cuba lagi.",
      USER_NOT_FOUND: "Pengguna tidak dijumpai. Log masuk semula dan cuba lagi.",
      INVALID_WALLET: "Sila masukkan alamat dompet penuh",
      INVALID_QUERY: "Pertanyaan tidak sah; masukkan sekurang-kurangnya 2 aksara",
      INVALID_AMOUNT: "Format amaun tidak sah",
      INVALID_PARAM: "Parameter tidak sah. Semak dan cuba lagi.",
      INVALID_FOLLOW: "Anda tidak boleh copy dagangan sendiri",
      TRADER_EXISTS: "Dompet ini sudah pedagang. Tidak perlu daftar semula.",
      TRADER_FULL: "Pedagang ini telah capai had pengikut",
      TRADER_CANCELLED: "Akaun pedagang ini telah dibatalkan",
      TRADER_REGISTER_FAILED: "Gagal daftar sebagai pedagang. Sila cuba lagi.",
      TRADER_SETTINGS_FAILED: "Gagal simpan tetapan pedagang. Sila cuba lagi.",
      NOT_A_TRADER: "Register as a trader first",
      TRADER_UNAVAILABLE: "This trader is currently unavailable",
      INSUFFICIENT_BALANCE: "Baki tersedia tidak mencukupi untuk membekukan deposit",
      BALANCE_TOO_LOW: "Baki akaun copy di bawah ambang trader ini. Pindahkan dari akaun dagangan dahulu",
      COPY_BALANCE_ZERO: "Baki akaun copy ialah 0. Pindahkan dari akaun dagangan dahulu",
      INSUFFICIENT_FUNDS: "Baki akaun dagangan tidak mencukupi untuk pindahan ke akaun copy",
      COPY_TRADE_BALANCE_INSUFFICIENT: "Baki tersedia akaun copy tidak mencukupi (stake/share beku tidak boleh dikeluarkan)",
      ACCOUNT_NOT_FOUND: "Ralat akaun. Sila cuba lagi.",
      ACCOUNT_CONFLICT: "Akaun sedang dikemas kini. Sila cuba lagi.",
      FOLLOW_EXISTS: "Anda sudah follow pedagang ini",
      FOLLOW_LIMIT: "Anda sudah ada hubungan copy aktif. Tamatkan dahulu sebelum follow pedagang lain.",
      FOLLOW_FAILED: "Gagal mula copy. Sila cuba lagi.",
      FOLLOW_NOT_FOUND: "Hubungan copy tidak dijumpai",
      PAUSE_FAILED: "Gagal jeda copy. Sila cuba lagi.",
      RESUME_FAILED: "Gagal sambung copy. Sila cuba lagi.",
      STOP_LOSS_THRESHOLD: "Stop-loss is still too low. Raise or clear it, then resume.",
      TAKE_PROFIT_THRESHOLD: "Take-profit is still too low. Raise or clear it, then resume.",
      END_FAILED: "Gagal tamatkan copy. Sila cuba lagi.",
      APPLICATION_NOT_FOUND: "Permohonan menunggu tidak dijumpai",
      APPROVE_FAILED: "Gagal luluskan permohonan. Sila cuba lagi.",
      REJECT_FAILED: "Gagal tolak permohonan. Sila cuba lagi.",
      KICK_FAILED: "Gagal alih keluar pengikut. Sila cuba lagi.",
      SETTLEMENT_WINDOW: "Tetapan pedagang tidak boleh diubah semasa tetingkap penyelesaian",
      CANCEL_FAILED: "Gagal minta pembatalan. Sila cuba lagi.",
      CANCEL_NOT_PENDING: "Tiada permintaan pembatalan untuk ditarik balik",
      CANCEL_WITHDRAW_FAILED: "Gagal tarik balik pembatalan. Sila cuba lagi.",
      COPY_SETTINGS_MISSING: "Tetapan copy trading belum sedia. Sila cuba lagi.",
      INVALID_SYMBOL: "Pilih sekurang-kurangnya satu simbol disokong",
      SYMBOL_NOT_ALLOWED: "Termasuk simbol yang tidak dibenarkan pedagang ini",
      TRADER_BALANCE_TOO_LOW: "Baki tersedia selepas pembekuan deposit terlalu rendah untuk daftar",
      TIMEOUT: "Operasi gagal. Sila cuba lagi.",
      NETWORK: "Operasi gagal. Sila cuba lagi."
    },
    status: {
      ACTIVE: "Aktif",
      PAUSED: "Dijeda",
      ENDED: "Tamat",
      PENDING_REVIEW: "Menunggu semakan pedagang",
      CANCEL_PENDING: "Pembatalan menunggu",
      CANCELLED: "Dibatalkan"
    },
    traderStatus: {
      ACTIVE: "Memimpin",
      CANCEL_PENDING: "Keluar",
      CANCELLED: "Dibatalkan",
    },
    pauseReason: {
      USER: "Dijeda oleh pengguna",
      INSUFFICIENT_BALANCE: "Dijeda: baki akaun copy tidak mencukupi",
      TAKE_PROFIT: "Take profit dicetuskan",
      STOP_LOSS: "Stop loss dicetuskan",
      TRADER_KICK: "Dialih keluar oleh pedagang",
      SWITCH: "Pedagang ditukar",
      SETTLEMENT_CLEANUP: "Dialih keluar pada penyelesaian mingguan",
      TRADER_CANCEL: "Pedagang dibatalkan"
    },
    followMode: {
      EQUAL: "Amaun sama",
      RATIO: "Nisbah"
    },
    insuranceMode: {
      FOLLOW: "Follow pedagang",
      ALWAYS_ON: "Sentiasa hidup",
      ALWAYS_OFF: "Sentiasa mati"
    },
    reviewMode: {
      AUTO: "Follow automatik",
      MANUAL: "Follow dengan semakan"
    },
    applicationStatus: {
      PENDING: "Menunggu",
      APPROVED: "Diluluskan",
      REJECTED: "Ditolak",
      CANCELLED: "Dibatalkan",
      PENDING_REVIEW: "Menunggu"
    }
  },}
